import React, { useState, useEffect, useRef,useCallback } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './Lobby.css';
import './CashTablesFullscreen.css';
import './LobbyRatingMobile.css';
import './LobbyMobileFlowFix.css';
import { useGame } from './context/GameContext';
import CashFortuneBarOverlay from './CashFortuneBarOverlay';
import tournamentSocket from './tournamentSocket';
import LongTournamentBackgammon from './LongTournamentBackgammon';
import LongTournamentLobby from './LongTournamentLobby';
 import LobbyFortune from './LobbyFortune';
import longTournamentSocket from './longTournamentSocket'; // обязательно 
// Короткий сокет
import socket from './socket';
// Длинный сокет
import longSocket from './longSocket';
import khachapuriSocket, { rememberKhachapuriRoom } from './khachapuriSocket';
import { useSound } from './sfx/SoundProvider';
import TournamentLobby from './TournamentLobby';
import LongTournamentBackgammonBoardDisplay from './LongTournamentBackgammonBoardDisplay';
import SpinWheelOverlay from './SpinWheelOverlay';
import SupportChatWidget from './SupportChatWidget';
import CountryFlag from './components/CountryFlag';

const Lobby = ({ token, username }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  console.log('[Lobby] mount', {
  path: location.pathname,
  search: location.search,
  state: location.state,
  wsConnected: socket.connected,
  longConnected: longSocket.connected,
});

  // Из контекста
  const {
    tableStates,
    setTableStates,
    tables,          // короткие столы
    setTables,
    tablesLong,      // длинные столы
    setTablesLong,
    tablesKhachapuri, // столы Хачапури
    setTablesKhachapuri,

    balance,
    setBalance,

    rollEnabled,
    setRollEnabled,
    currentTableId,
    setCurrentTableId,
    blockStol, setBlockStol,
    tickets,
     setTickets,
     skins, 
     setSkins
    // Если нужно что-то ещё – добавьте
  } = useGame();

  // 0 = короткие, 1 = длинные, 2 = Хачапури.
  // При возврате в Lobby восстанавливаем последнюю открытую cash-вкладку.
  const getInitialCashTab = () => {
    try {
      const savedTab = localStorage.getItem('lobbyCashTab');
      if (savedTab === 'short' || savedTab === 'long' || savedTab === 'khachapuri') {
        return savedTab;
      }

      // Fallback: если игрок только что был за игровым столом.
      const gameType = localStorage.getItem('gameType');
      if (gameType === 'khachapuri') return 'khachapuri';
      if (gameType === 'long') return 'long';
      if (gameType === 'short') return 'short';
    } catch (e) {}

    return 'short';
  };

  const initialCashTab = getInitialCashTab();

  const [typeGame, setTypeGame] = useState(
    initialCashTab === 'khachapuri' ? 2 : initialCashTab === 'long' ? 1 : 0
  );
  const [activeTournaments, setActiveTournaments] = useState([]);
  const [isLongRefreshing, setIsLongRefreshing] = useState(false);
  const [isShortRefreshing, setIsShortRefreshing] = useState(false); 
  const [isKhachapuriRefreshing, setIsKhachapuriRefreshing] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [countryByUsername, setCountryByUsername] = useState({});
  const [ratingTab, setRatingTab] = useState(
    initialCashTab === 'short' ? 'short' : 'long'
  );
  const [cashTab, setCashTab] = useState(initialCashTab);
  const [tablesExpanded, setTablesExpanded] = useState(false);

  /*
    Полноэкранный список на телефоне работает без изменения meta viewport.
    Это важно: временная подмена viewport после сворачивания ломала масштаб
    всего лобби. Вместо этого компенсируем старую ширину сайта только у
    полноэкранного слоя.
  */
  const [tablesFullscreenView, setTablesFullscreenView] = useState({
    compensated: false,
    zoom: 1,
    width: '100vw',
    height: '100dvh',
  });

  const tablesLobbyScrollRef = useRef({
    element: null,
    top: 0,
    left: 0,
  });

  const isJoiningRef = useRef(false);

  const finishedShortTableIdsRef = useRef(new Set());



  // === HIDE FINISHED TABLES (короткие) ===
const normStatus = (s) => String(s ?? '').trim().toLowerCase();

const isHiddenLobbyStatus = (s) => {
  const st = normStatus(s);
  return st === 'finished' || st === 'closed';
};

// универсальный фильтр списка столов
const filterVisibleTables = (arr) => {
  const finishedIds = finishedShortTableIdsRef.current;
  if (!Array.isArray(arr)) return [];

  return arr.filter((t) => {
    if (!t) return false;
    if (finishedIds.has(t.id)) return false;      // если мы уже “пометили” как finished — не показываем
    if (isHiddenLobbyStatus(t.status)) return false;
    return true;
  });
};


  const longTablesRequestedRef = useRef(false); 
  const [tournamentRefreshTick, setTournamentRefreshTick] = useState(0);
  const lastLongTablesRequestTimeRef = useRef(0);
  const [shortTournaments, setShortTournaments] = useState([]);
  const [longTournaments, setLongTournaments] = useState([]);



  
  // 👇 ДОБАВЛЯЕМ: состояние для обучения
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingStep, setOnboardingStep] = useState(0);

  // 👇 Слайды обучения (текст можно потом подправить)
  const onboardingSlides = [
    {
      id: 0,
      title: t('lobby.onboarding.welcomeTitle'),
      text: t('lobby.onboarding.welcomeText')
    },
    {
      id: 1,
      title: t('lobby.onboarding.slides.tables.title'),
      text: t('lobby.onboarding.slides.tables.text')
    },
    {
      id: 2,
      title: t('lobby.onboarding.slides.tournaments.title'),
      text: t('lobby.onboarding.slides.tournaments.text')
    },
    {
      id: 3,
      title: t('lobby.onboarding.slides.rating.title'),
      text: t('lobby.onboarding.slides.rating.text')
    },
    {
      id: 4,
      title: t('lobby.onboarding.slides.fortune.title'),
      text: t('lobby.onboarding.slides.fortune.text')
    },
    {
      id: 5,
      title: t('lobby.onboarding.slides.profile.title'),
      text: t('lobby.onboarding.slides.profile.text')
    },
    {
      id: 6,
      title: t('lobby.onboarding.slides.menu.title'),
      text: t('lobby.onboarding.slides.menu.text')
    },
    {
      id: 7,
      title: t('lobby.onboarding.slides.profileButton.title'),
      text: t('lobby.onboarding.slides.profileButton.text')
    }
  ];





  // Шаг 1 — кеш-столы + вкладки "КОРОТКИЕ / ДЛИННЫЕ"
 // 1: кеш-столы
const isOnboardingCashSection        = showOnboarding && onboardingStep === 1;
// 2: турнирные карточки (short/long)
const isOnboardingTournamentCards    = showOnboarding && onboardingStep === 2;

// 3: рейтинг
const isOnboardingRatingSection      = showOnboarding && onboardingStep === 3;
// 4: колесо
const isOnboardingWheelSection       = showOnboarding && onboardingStep === 4;
// 5: баланс / верхняя панель
const isOnboardingBalanceSection     = showOnboarding && onboardingStep === 5;





// 👇 ПОДСВЕТКА ХЕДЕРА / МЕНЮ / ПРОФИЛЯ НА ШАГАХ 5–7
useEffect(() => {
  // какие элементы вообще чистим
  const selectors = [
    '.userbox',          // аватар + логин + баланс
    '.statsbar-dock',    // плашка с уровнем / билетами / скинами
    '.header-inner .menu', // верхнее меню: нарды / квесты / покер
    '.button-profile',   // кнопка профиля справа
  ];

  const clearAll = () => {
    selectors.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el) {
        el.classList.remove('onboarding-highlight', 'onboarding-highlight-pulse');
      }
    });
  };

  // всегда сначала всё очищаем
  clearAll();

  // если обучение скрыто — дальше ничего не делаем
  if (!showOnboarding) return;

  // Шаг 5 — профиль, баланс, награды: подсвечиваем блок юзера + плашку статов
  if (onboardingStep === 5) {
    const userbox = document.querySelector('.userbox');
    const stats   = document.querySelector('.statsbar-dock');
    if (userbox) userbox.classList.add('onboarding-highlight', 'onboarding-highlight-pulse');
    if (stats)   stats.classList.add('onboarding-highlight', 'onboarding-highlight-pulse');
  }

  // Шаг 6 — главное меню (нарды / квесты / покер)
  if (onboardingStep === 6) {
    const menu = document.querySelector('.header-inner .menu');
    if (menu) {
      menu.classList.add('onboarding-highlight', 'onboarding-highlight-pulse');
    }
  }

  // Шаг 7 — кнопка профиля
  if (onboardingStep === 7) {
    const profileBtn = document.querySelector('.button-profile');
    if (profileBtn) {
      profileBtn.classList.add('onboarding-highlight', 'onboarding-highlight-pulse');
    }
  }

  // на размонтировании / смене шага подчистим
  return () => {
    clearAll();
  };
}, [showOnboarding, onboardingStep]);



    // 👇 Кнопка "Далее"
  const handleOnboardingNext = () => {
    if (onboardingStep >= onboardingSlides.length - 1) {
      // последний шаг — считаем обучение пройденным
      localStorage.setItem('bgq_onboarding_done', '1');
      setShowOnboarding(false);
    } else {
      setOnboardingStep((s) => s + 1);
    }
  };

  // 👇 Кнопка "Назад"
  const handleOnboardingPrev = () => {
    if (onboardingStep > 0) {
      setOnboardingStep((s) => s - 1);
    }
  };

  // 👇 Кнопка "Потом" (пропустить обучение)
  const handleOnboardingSkip = () => {
    localStorage.setItem('bgq_onboarding_done', '1');
    setShowOnboarding(false);
  };

  // 👇 Кнопка "Пройти обучение" на первом экране
  const handleOnboardingStart = () => {
    setOnboardingStep(1);       // переходим к шагу "Баланс"
  };



  // 👇 Кнопка "Повторить обучение" в лобби
  const handleOnboardingRestart = () => {
    try {
      // убираем пометку "обучение пройдено"
      localStorage.removeItem('bgq_onboarding_done');
    } catch {}

    // запускаем обучение с самого начала (экран приветствия)
    setOnboardingStep(0);
    setShowOnboarding(true);
  };



  const [cashWheel, setCashWheel] = useState({
  show: false,
  segments: [],
  selectedId: null,
  title: 'Ваш приз',
});

const isMobile = window.innerWidth <= 1000;



const hasToken = Boolean(token || localStorage.getItem('token'));
const isGuest = !hasToken;



const { play } = useSound();

const refreshShortTables = () => {
  if (isGuest) return; 
  if (isShortRefreshing) return;
  setIsShortRefreshing(true);
  const finish = () => setIsShortRefreshing(false);

  const request = () => {
    // перезаходим в комнату (безвредно, если уже в ней)
    socket.emit('joinShortLobby');
    socket.emit('joinLobby');
socket.emit('requestTables', (fresh) => {
  const arr = Array.isArray(fresh) ? fresh : [];

  console.groupCollapsed(`[SHORT ACK] requestTables -> ${arr.length} tables`);
  console.table(arr.slice(0, 25).map(t => ({
    id: t?.id,
    status: t?.status,
    p1: t?.player1_name,
    p2: t?.player2_name,
    match: t?.match_points,
  })));
  console.log('[SHORT ACK] hiddenIds size =', finishedShortTableIdsRef.current.size);
  console.groupEnd();

  setTables(filterVisibleTables(arr));
  finish();
});


  };

  if (socket.connected) {
    request();
  } else {
    socket.connect();
    socket.once('connect', request);
    setTimeout(finish, 4000);
  }
};


// const refreshShortTables = () => {
//   if (isShortRefreshing) return;
//   setIsShortRefreshing(true);

//   const finish = () => setIsShortRefreshing(false);

//   const request = () => {
//     // ACK-снимок списка коротких столов (сервер вызывает callback(fresh))
//     socket.emit('requestTables', (fresh) => {
//       setTables(Array.isArray(fresh) ? fresh : []);
//       finish();
//     });
//   };

//   if (socket.connected) {
//     request();
//   } else {
//     socket.connect();
//     socket.once('connect', request);
//     // защита от зависания кнопки, если что-то пойдёт не так
//     setTimeout(finish, 4000);
//   }
// };

// При активации вкладки/фокусе окна — страхуемся свежим ACK для short
useEffect(() => {
  const onFocus = () => refreshShortTables();
  const onVisible = () => {
    if (document.visibilityState === 'visible') refreshShortTables();
  };
  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisible);
  return () => {
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisible);
  };
}, []);










// ✅ СЕРВЕР ШЛЁТ shortTableUpsert — ловим и сразу убираем finished из лобби
// useEffect(() => {
//   const onShortUpsert = (tbl) => {
//     if (!tbl?.id) return;

//     const st = normStatus(tbl.status);

//     // если finished/closed — помечаем и удаляем из state
//     if (st === 'finished' || st === 'closed') {
//       finishedShortTableIdsRef.current.add(tbl.id);
//       setTables((prev) => prev.filter((t) => t.id !== tbl.id));
//       return;
//     }

//     // иначе обычный upsert (обновить/добавить)
//     setTables((prev) => {
//       const i = prev.findIndex((t) => t.id === tbl.id);
//       if (i === -1) return [...prev, tbl];
//       const copy = prev.slice();
//       copy[i] = { ...copy[i], ...tbl };
//       return copy;
//     });
//   };

//   socket.on('shortTableUpsert', onShortUpsert);

//   return () => {
//     socket.off('shortTableUpsert', onShortUpsert);
//   };
// }, [setTables]);



// Мягкий периодический ACK-пуллинг short-столов, пока вкладка видима
useEffect(() => {
  let timer = null;

  const tick = () => {
    if (document.visibilityState !== 'visible') return;
    // только если мы вообще показываем короткие столы в правой колонке
    refreshShortTables();
  };

  // первый вызов через 1.2с после маунта (часто помогает убрать «фантом» сразу)
  const first = setTimeout(tick, 1200);
  timer = setInterval(tick, 7000); // раз в 7 секунд — не агрессивно

  return () => {
    clearTimeout(first);
    clearInterval(timer);
  };
}, []);




// 👇 Показ обучения после регистрации (только для ПК, на мобилках отключаем)
useEffect(() => {
  // На мобильных обучение полностью выключено
  if (isMobile) return;

  // Только для авторизованных
  if (!username) return;

  const done  = localStorage.getItem('bgq_onboarding_done');
  const start = localStorage.getItem('bgq_onboarding_start');

  if (done) return;

  if (start) {
    setShowOnboarding(true);
    setOnboardingStep(0);
    localStorage.removeItem('bgq_onboarding_start');
  }
}, [username, isMobile]);

  // 👇 Показ обучения после регистрации
  // useEffect(() => {
  //   // Только для авторизованных (у гостя нет смысла)
  //   if (!username) return;

  //   const done  = localStorage.getItem('bgq_onboarding_done');
  //   const start = localStorage.getItem('bgq_onboarding_start');

  //   // Если обучение уже проходили — ничего не делаем
  //   if (done) return;

  //   // Если после регистрации поставили флаг — показываем модалку
  //   if (start) {
  //     setShowOnboarding(true);
  //     setOnboardingStep(0);           // первый экран — приветствие
  //     localStorage.removeItem('bgq_onboarding_start'); // чтобы не повторялось при F5
  //   }
  // }, [username]);




const refreshLongTables = () => {
  if (isGuest) return;
  if (isLongRefreshing) return;
  setIsLongRefreshing(true);

  const finish = () => setIsLongRefreshing(false);

  const request = () => {
    // ACK-снимок списка от сервера
    longSocket.emit('requestLongTables', (list) => {
      setTablesLong(Array.isArray(list) ? list : []);
      finish();
    });
  };







  
  // гарантируем подключение и комнату
  if (longSocket.connected) {
    longSocket.emit('joinLongLobby');
    request();
  } else {
    longSocket.connect();
    longSocket.once('connect', () => {
      longSocket.emit('joinLongLobby');
      request();
    });
    // таймаут-защита, чтобы кнопка не зависла
    setTimeout(finish, 4000);
  }
};



const refreshKhachapuriTables = () => {
  if (isGuest) return;
  if (isKhachapuriRefreshing) return;

  setIsKhachapuriRefreshing(true);
  const finish = () => setIsKhachapuriRefreshing(false);

  const request = () => {
    khachapuriSocket.emit('joinKhachapuriLobby');
    khachapuriSocket.emit('requestKhachapuriTables', (list) => {
      setTablesKhachapuri(Array.isArray(list) ? list : []);
      finish();
    });
  };

  if (khachapuriSocket.connected) {
    request();
  } else {
    try {
      const token = localStorage.getItem('token');
      khachapuriSocket.auth = token ? { token } : {};
    } catch (e) {}

    khachapuriSocket.connect();
    khachapuriSocket.once('connect', request);
    setTimeout(finish, 4000);
  }
};



// где-нибудь рядом с другими эффектами:
useEffect(() => {
  if (!location.state?.refreshTournaments) return;

  // инкрементим тик — это сигнал вниз
  setTournamentRefreshTick(t => t + 1);

  // очищаем state, чтобы не сработало повторно при back/forward
  navigate('.', { replace: true, state: {} });
}, [location.state, navigate]);

useEffect(() => {
  if (!socket.connected) socket.connect();
}, []);



// 👇 гарантированный начальный запрос списков турниров (short + long)
useEffect(() => {
  // первая попытка сразу
  fetchTournaments();
  // и мягкий повтор через 900 мс — если первый раз пришло пусто
  const t = setTimeout(fetchTournaments, 900);
  return () => clearTimeout(t);
}, []); // <- без зависимостей





useEffect(() => {
  let unmounted = false;

  const pullSnapshot = () => {
    longSocket.emit('requestLongTables', (list) => {
      console.log('[LONG ACK] requestLongTables ->', list);
      if (!unmounted) setTablesLong(Array.isArray(list) ? list : []);
    });
  };

  const upsert = (tbl) => {
    console.log('[LONG PUSH] longTableUpdated ->', tbl);
    setTablesLong(prev => {
      const i = prev.findIndex(t => t.id === tbl.id);
      if (i === -1) return [...prev, tbl];
      const copy = prev.slice();
      copy[i] = { ...copy[i], ...tbl };
      return copy;
    });
  };

  const onList    = (list) => {
    console.log('[LONG PUSH] longTablesList ->', list);
    setTablesLong(Array.isArray(list) ? list : []);
  };
  const onDeleted = ({ tableId }) => {
    console.log('[LONG PUSH] longTableDeleted ->', tableId);
    setTablesLong(prev => prev.filter(t => t.id !== tableId));
  };

  longSocket.on('longTablesList', onList);
  longSocket.on('longTableUpdated', upsert);
  longSocket.on('longTableDeleted', onDeleted);

  // fallback на старые имена, если где-то ещё остались
  longSocket.on('tableUpdated', upsert);
  longSocket.on('tableDeleted', onDeleted);

  const afterConnect = () => {
    console.log('[LONG] connected → joinLongLobby');
    longSocket.emit('joinLongLobby', (resp) => {
      console.log('[LONG ACK] joinLongLobby ->', resp);
      if (resp?.ok) pullSnapshot();
      else pullSnapshot(); // даже если ACK нет/ошибка — попробуем дернуть список
    });
  };

  if (longSocket.connected) afterConnect();
  else {
    longSocket.connect();
    longSocket.once('connect', afterConnect);
  }

  return () => {
    unmounted = true;
    longSocket.off('longTablesList', onList);
    longSocket.off('longTableUpdated', upsert);
    longSocket.off('longTableDeleted', onDeleted);
    longSocket.off('tableUpdated', upsert);
    longSocket.off('tableDeleted', onDeleted);
    longSocket.off('connect', afterConnect);
  };
}, [setTablesLong]);





// ⚙️ Единая функция подгрузки турниров (короткие + длинные)
const fetchTournaments = useCallback(() => {
  const askShort = () => tournamentSocket.emit('requestAllTournaments');
  const askLong  = () => longTournamentSocket.emit('requestAllTournaments');

  if (tournamentSocket.connected) askShort();
  else tournamentSocket.once('connect', askShort);

  if (longTournamentSocket.connected) askLong();
  else longTournamentSocket.once('connect', askLong);
}, []);


// 🔁 Обновлять турниры, когда вкладка становится активной/окно получает фокус
useEffect(() => {
  const onFocus = () => fetchTournaments();
  const onVisible = () => {
    if (document.visibilityState === 'visible') fetchTournaments();
  };
  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisible);
  return () => {
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisible);
  };
}, [fetchTournaments]);


// ⏱️ Подгружаем турниры при "сигнале обновления" и после выхода со столов
useEffect(() => {
  // первая попытка — сразу с небольшой задержкой (сервер успеет очистить стол)
  const t1 = setTimeout(fetchTournaments, 700);

  // если оба списка пустые — ещё 2 попытки с бэкоффом
  const t2 = setTimeout(() => {
    if (shortTournaments.length === 0 && longTournaments.length === 0) {
      fetchTournaments();
    }
  }, 1800);

  const t3 = setTimeout(() => {
    if (shortTournaments.length === 0 && longTournaments.length === 0) {
      fetchTournaments();
    }
  }, 3500);

  return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
}, [tournamentRefreshTick, fetchTournaments, shortTournaments.length, longTournaments.length]);

// 🧯 На всякий случай: если оба списка пустые прямо сейчас — подёргаем один раз через 1.2s
useEffect(() => {
  if (shortTournaments.length > 0 || longTournaments.length > 0) return;
  const t = setTimeout(fetchTournaments, 1200);
  return () => clearTimeout(t);
}, [shortTournaments.length, longTournaments.length, fetchTournaments]);









useEffect(() => {
  const ask = () => fetchTournaments();
  tournamentSocket.on('connect', ask);
  longTournamentSocket.on('connect', ask);
  // если используете socket.io v4, можно также:
  tournamentSocket.on('reconnect', ask);
  longTournamentSocket.on('reconnect', ask);

  return () => {
    tournamentSocket.off('connect', ask);
    longTournamentSocket.off('connect', ask);
    tournamentSocket.off('reconnect', ask);
    longTournamentSocket.off('reconnect', ask);
  };
}, [fetchTournaments]);




useEffect(() => {
  const askShort = () => tournamentSocket.emit('requestAllTournaments');
  const askLong = () => longTournamentSocket.emit('requestAllTournaments');

  const handleShort = (all) => {
    const short = all.filter(t => t.gameType !== 'long' && t.status !== 'finished');
    setShortTournaments(short);
  };

  const handleLong = (all) => {
    const long = all.filter(t => t.gameType === 'long' && t.status !== 'finished');
    setLongTournaments(long);
  };

  tournamentSocket.on('responseAllTournaments', handleShort);
  longTournamentSocket.on('responseAllTournaments', handleLong);

  if (tournamentSocket.connected) askShort();
  else tournamentSocket.once('connect', askShort);

  if (longTournamentSocket.connected) askLong();
  else longTournamentSocket.once('connect', askLong);

  return () => {
    tournamentSocket.off('responseAllTournaments', handleShort);
    longTournamentSocket.off('responseAllTournaments', handleLong);
  };
}, []);




useEffect(() => {
  const onConnect = () => console.log('[SOCKET] connected id=', socket.id);
  const onDisconnect = (reason) => console.log('[SOCKET] disconnected:', reason);
  const onConnectError = (err) => console.log('[SOCKET] connect_error:', err?.message);

  socket.on('connect', onConnect);
  socket.on('disconnect', onDisconnect);
  socket.on('connect_error', onConnectError);

  return () => {
    socket.off('connect', onConnect);
    socket.off('disconnect', onDisconnect);
    socket.off('connect_error', onConnectError);
  };
}, []);


function buildNiceSegments(prizeValue = 0) {
  // Базовые опции (можешь под себя подправить)
  const coins = [1, 2, 3, 5, 10, 20].map(v => ({
    id: `coins_${v}`, label: `$${v}`, value: v, currency: '$',
  }));

  const specials = [
    { id: 'ticket_5',  label: 'Билет $5',   badge: 'TICKET', type: 'ticket', value: 5, count: 1 },
    { id: 'bonus_spin',label: 'Бонус-спин', badge: 'BONUS',  type: 'bonus' },
    { id: 'skin_bronze', label: 'Скин «Бронза»', badge: 'SKIN', type: 'skin', skin_type: 'bronze', count: 1 },
    { id: 'empty', label: 'Пусто' },
  ];

  // Лента из 10 «плиток»
  const base = [
    coins[0], coins[1], specials[0],
    coins[2], specials[1], coins[3],
    specials[2], coins[4], specials[3],
    coins[5],
  ];

  // Выбираем, какой id подсветить, исходя из выигрыша
  let selectedId = 'empty';
  if (prizeValue > 0) {
    const nearest = [...coins].reverse().find(c => c.value <= prizeValue) || coins[0];
    selectedId = nearest.id;
    const idx = base.findIndex(x => x.id.startsWith('coins_'));
    if (idx >= 0) base[idx] = { ...nearest };
  }

  return { segments: base, selectedId };
}


useEffect(() => {
  const onRefresh = () => {
    // дергаем оба сокета турниров
    fetchTournaments();
    // пометим «сигнал обновления» — на него уже завязаны твои бэкофф-повторы
    setTournamentRefreshTick(t => t + 1);
    // и подстрахуем столы (короткие/длинные)
    setTimeout(() => {
      refreshShortTables();
      refreshLongTables();
    }, 400); // дадим серверу «досохранить» исход партии/бонуски
  };
  window.addEventListener('tournaments-refresh', onRefresh);
  return () => window.removeEventListener('tournaments-refresh', onRefresh);
}, [fetchTournaments]);




// 👇 заменить целиком
const handleCollectPrize = async (result) => {
  try {
    // 🔎 ЛОГ №1: входящий payload из Overlay
    console.log('[Lobby] onCollect payload:', result);

    const authToken = token || localStorage.getItem('token');
    if (!authToken) {
      console.warn('[Lobby] нет токена — серверный collect пропущен (гость)');
      return; // гостевой режим — просто закроется
    }

    // const API_BASE =
    //   (import.meta?.env?.VITE_API_BASE) ||
    //   (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL + '/api');
const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';


    // серверное вращение или fallback?
    const isServerRoll = cashWheel.fromServer === true;

    // из Overlay теперь приходит result.winner?.id
    const winId   = result?.winner?.id ?? null;
    const outcome = result?.isWin ? 'win' : 'lose';

    // 🔎 ЛОГ №2: что именно планируем отправить
    console.log('[Lobby] collect → will send', { API_BASE, isServerRoll, outcome, winId });

    // ⚠️ Изменение логики: вызываем сервер ВСЕГДА при server roll,
    // даже если winId === null (проигрыш), чтобы сервер ЗНАЛ об исходе.
    if (API_BASE) {
      const url = `${API_BASE}/fortuneGame/collect`;
      const body = { outcome, winId }; // сервер получит 'win'|'lose' и опциональный winId

      console.time('[Lobby] fetch /fortuneGame/collect');
      const res  = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify(body),
      });
      const raw  = await res.text(); // сырой ответ для диагностики
      console.timeEnd('[Lobby] fetch /fortuneGame/collect');

      // 🔎 ЛОГ №3: статус + сырой ответ
      console.log('[Lobby] collect response:', { status: res.status, raw });

      // пробуем распарсить JSON (если сервер вернул JSON)
      let json = null;
      try { json = raw ? JSON.parse(raw) : null; } catch {}
      if (!res.ok) throw new Error(json?.message || `collect failed (${res.status})`);

      // обновляем баланс/ассеты, если сервер прислал
      if (json?.balance !== undefined) setBalance(json.balance);
      if (json?.assets?.tickets) setTickets(json.assets.tickets);
      if (json?.assets?.skins)   setSkins(json.assets.skins);

      // пушим события на верхний уровень интерфейса
      window.dispatchEvent(new CustomEvent('balance-updated', {
        detail: { balance: json?.balance, source: 'collect', allowDecrease: true }
      }));
      window.dispatchEvent(new CustomEvent('assets-updated', {
        detail: json?.assets || {}
      }));
    } else {
      console.warn('[Lobby] collect SKIPPED', { reason: 'not server roll or no API_BASE', API_BASE, isServerRoll });
    }
  } catch (e) {
    console.warn('[Lobby] collect error:', e);
    // TODO: показать toast, если используешь
  }
};



// 👇 добавить в Lobby.jsx
// const handleCollectPrize = async (seg) => {
//   try {
//     const authToken = token || localStorage.getItem('token');
//     if (!authToken) return;            // гостевой режим — просто закроется

//     const API_BASE =
//       (import.meta?.env?.VITE_API_BASE) ||
//       (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL + '/api');

//     // если колёсo пришло с сервера, мы пометили это флагом (см. ниже)
//     const isServerRoll = cashWheel.fromServer === true;

//     // id выигрыша: в серверном кейсе — GUID/ID из roll.win.id,
//     // в fallback – наши условные id (coins_5 и т.п.), их не отправляем
//     const winId = isServerRoll ? (seg?.id || cashWheel.selectedId) : null;

//     // дергаем collect только если был реальный roll на сервере
//     if (API_BASE && winId) {
//       const res = await fetch(`${API_BASE}/fortuneGame/collect`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${authToken}`,
//         },
//         body: JSON.stringify({ winId }),
//       });
//       const json = await res.json();

//       if (!res.ok) throw new Error(json?.message || `collect failed (${res.status})`);

//       // при желании обновляем баланс, если сервер вернул
//       if (json?.balance !== undefined) setBalance(json.balance);
// if (json?.assets?.tickets) setTickets(json.assets.tickets);
// if (json?.assets?.skins)   setSkins(json.assets.skins);



// // 👇 пушим события, чтобы App.js и Header узнали об обновлении
// // пушим события, чтобы App.js и Header узнали об обновлении
// window.dispatchEvent(new CustomEvent('balance-updated', {
//   detail: { balance: json.balance, source: 'collect', allowDecrease: true }
// }));
// window.dispatchEvent(new CustomEvent('assets-updated', {
//   detail: json.assets || {}
// }));

//  // если у тебя есть сокет-ивент на баланс — можно подтолкнуть:
//       // socket.emit('requestUserBalance'); // опционально
//     }
//   } catch (e) {
//     console.warn('[CASH] collect error:', e);
//     // тут можно показать toast, если используешь
//   }
// };





const goShortTab = () => {
  // звук для КОРОТКИХ
  // .catch(() => {}) — чтобы не падать, если браузер заблокирует автоплей
  play('backgammon').catch(() => {});
  try { localStorage.setItem('lobbyCashTab', 'short'); } catch (e) {}
  setCashTab('short');
  setTypeGame(0);
};

const goLongTab = () => {
  // звук для ДЛИННЫХ
  play('nardgammon').catch(() => {});
  try { localStorage.setItem('lobbyCashTab', 'long'); } catch (e) {}
  setCashTab('long');
  setTypeGame(1);
};


const goKhachapuriTab = () => {
  play('nardgammon').catch(() => {});
  try { localStorage.setItem('lobbyCashTab', 'khachapuri'); } catch (e) {}
  setCashTab('khachapuri');
  setTypeGame(2);
  refreshKhachapuriTables();
};

  // =========================================
  // 1) Баланс
  // =========================================

const userLevel = 1;   // ← подставь реальные значения
const userVip   = 0;

 useEffect(() => {
   const gt = new URLSearchParams(location.search).get('gt');

   if (gt === 'khachapuri') {
     try { localStorage.setItem('lobbyCashTab', 'khachapuri'); } catch (e) {}
     setTypeGame(2);
   }

   if (gt === 'long') {
     try { localStorage.setItem('lobbyCashTab', 'long'); } catch (e) {}
     setTypeGame(1);
   }

   if (gt === 'short') {
     try { localStorage.setItem('lobbyCashTab', 'short'); } catch (e) {}
     setTypeGame(0);
   }
 }, [location.search]);

  useEffect(() => {
    const nextCashTab =
      typeGame === 2
        ? 'khachapuri'
        : typeGame === 1
          ? 'long'
          : 'short';

    setCashTab(nextCashTab);

    // У рейтинга пока только short / long.
    // Хачапури не должен ломать ratingTab.
    setRatingTab(typeGame === 0 ? 'short' : 'long');

    try {
      localStorage.setItem('lobbyCashTab', nextCashTab);
    } catch (e) {}
  }, [typeGame]);





// ⬇️ ЗАМЕНИ ЭТОТ ЭФФЕКТ
// ⬇️ СЕРВЕРНАЯ ВЕРСИЯ – дергаем /pending и /roll
useEffect(() => {
  const wheel   = location.state?.openCashWheel;
  const cashBar = location.state?.cashBar;

  console.log('[Lobby] state-effect start', {
    state: location.state,
    wsConnected: socket.connected,
    longConnected: longSocket.connected,
  });

  // ⬇️ Если пришли из BoardDisplay — подстраховываемся свежими списками
//   if (location.state?.openCashWheel || location.state?.cashBar) {
//     console.log('[Lobby] пришли из BoardDisplay — отложенные запросы fresh столов');

//     // 1) КОРОТКИЕ: ACK-снимок через 1.0s
//     // setTimeout(() => {
//     //   socket.emit('requestTables', (fresh) => {
//     //     console.log('[Lobby] получили обновлённые столы (short):', fresh);
//     //     setTables(Array.isArray(fresh) ? fresh : []);
//     //   });
//     // }, 1000);
//     setTimeout(() => {
//   refreshShortTables();
// }, 900); // 800–1200 мс — норм


  if (location.state?.openCashWheel || location.state?.cashBar) {
    console.log('[Lobby] пришли из BoardDisplay — отложенные запросы fresh столов');

    // Короткие — резервный запрос
    setTimeout(() => {
      if (socket.connected) {
        refreshShortTables();
      } else {
        socket.connect();
        socket.once('connect', () => {
          console.log('[FIX] сокет подключился — делаю ручной запрос столов');
          refreshShortTables();
        });
      }
    }, 1000);

   

 
    // 2) ДЛИННЫЕ: вход в лобби + ACK-снимок через 1.2s
    setTimeout(() => {
      const pullLong = () => {
        longSocket.emit('joinLongLobby'); // чтобы гарантировать бродкасты
        longSocket.emit('requestLongTables', (list) => {
          console.log('[Lobby] получили обновлённые столы (long):', list);
          setTablesLong(Array.isArray(list) ? list : []);
        });
      };

      if (longSocket.connected) {
        pullLong();
      } else {
        longSocket.connect();
        longSocket.once('connect', pullLong);
      }
    }, 1200);
  }

  // Если нет повода открывать колесо — выходим из эффекта
  if (!wheel && !cashBar) return;

  let aborted = false;

  (async () => {
    try {
      // 1) Редкий кейс: пришли уже готовые сегменты — просто показать
      if (wheel && Array.isArray(wheel.segments) && wheel.selectedId) {
        if (aborted) return;
        setCashWheel({
          show: true,
          segments: wheel.segments,
          selectedId: wheel.selectedId,
          title: wheel.title || 'Ваш приз',
          fromServer: true,
        });
        return;
      }

      // 2) Обычный путь: проверяем pending → крутим roll
      const authToken = token || localStorage.getItem('token'); // если проп не прокинули

      if (!authToken) {
        console.warn('[CASH] нет токена — показываю fallback-визуал без начислений');
        const bet   = Number(cashBar?.bet) || 0;
        const mult  = Number(cashBar?.betMultiplier) || 1;
        const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
        const nice  = buildNiceSegments(prize);
        if (aborted) return;
        setCashWheel({
          show: true,
          segments: nice.segments,
          selectedId: nice.selectedId,
          title: 'Ваш приз',
          fromServer: false,
        });
        return;
      }

      // const API_BASE =
      //   (import.meta?.env?.VITE_API_BASE) ||
      //   (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL + '/api');
const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : '/api';


      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      };

      // 2.1) pending?
      const pendRes = await fetch(`${API_BASE}/fortuneGame/pending`, {
        method: 'GET',
        headers,
      });
      const pendJson = await pendRes.json();

      if (!pendRes.ok || !pendJson?.pending) {
        console.warn('[CASH] pending=false — показываю fallback-визуал');
        const bet   = Number(cashBar?.bet) || 0;
        const mult  = Number(cashBar?.betMultiplier) || 1;
        const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
        const nice  = buildNiceSegments(prize);
        if (aborted) return;
        setCashWheel({
          show: true,
          segments: nice.segments,
          selectedId: nice.selectedId,
          title: 'Ваш приз',
          fromServer: false,
        });
        return;
      }

      // 2.2) roll!
      const rollRes = await fetch(`${API_BASE}/fortuneGame/roll`, {
        method: 'POST',
        headers,
        body: JSON.stringify({}), // сюда можно подать forceId для тестов
      });
      const rollJson = await rollRes.json();

      if (!rollRes.ok || !rollJson?.ok || !rollJson?.win?.id) {
        throw new Error(`roll failed: ${rollRes.status}`);
      }

      // сервер дал strip (лента) и win.id — Overlay сам докрутит к selectedId
      // const segs = Array.isArray(rollJson.strip) ? rollJson.strip : [];
      // if (aborted) return;
      // setCashWheel({
      //   show: true,
      //   segments: segs,
      //   selectedId: rollJson.win.id,
      //   title: 'Ваш приз',
      //   fromServer: true,
      // });
      const segs = Array.isArray(rollJson.strip) ? rollJson.strip : [];

// если бэк уже присылает индекс — используем его:
const winIndexFromApi =
  (Number.isInteger(rollJson.winIndex) ? rollJson.winIndex :
   Number.isInteger(rollJson.win_index) ? rollJson.win_index : null);

// если индекса нет — вычислим локально по id:
const idxById = segs.findIndex(s => String(s?.id) === String(rollJson?.win?.id));
const selectedIndex = Number.isInteger(winIndexFromApi) ? winIndexFromApi : (idxById >= 0 ? idxById : 0);

setCashWheel({
  show: true,
  segments: segs,
  selectedId: rollJson?.win?.id ?? null, // запасной канал
  selectedIndex,                          // главный канал
  title: 'Ваш приз',
  fromServer: true,
});

    } catch (e) {
      console.error('[CASH] ошибка запроса:', e);

      // Крайний случай — красивый fallback
      const bet   = Number(cashBar?.bet) || 0;
      const mult  = Number(cashBar?.betMultiplier) || 1;
      const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
      const nice  = buildNiceSegments(prize);
      if (!aborted) {
        setCashWheel({
          show: true,
          segments: nice.segments,
          selectedId: nice.selectedId,
          title: 'Ваш приз',
          fromServer: false,
        });
      }
    } finally {
      // очень важно: очищаем history state — иначе эффект сработает снова при back/forward
      if (!aborted) navigate('.', { replace: true, state: {} });
    }
  })();

  return () => { aborted = true; };
}, [location.state, navigate, token, setTables, setTablesLong]);

// useEffect(() => {
//   const wheel   = location.state?.openCashWheel;
//   const cashBar = location.state?.cashBar;
// console.log('[Lobby] state-effect start', { state: location.state, wsConnected: socket.connected });

 
// // ⬇️ Если пришли из BoardDisplay — запрашиваем список с задержкой
// if (location.state?.openCashWheel || location.state?.cashBar) {
//   console.log('[Lobby] пришли из BoardDisplay — отложенный запрос fresh столов');
//   setTimeout(() => {
//     socket.emit('requestTables', (fresh) => {
//       console.log('[Lobby] получили обновлённые столы:', fresh);
//       setTables(Array.isArray(fresh) ? fresh : []);
//     });
//   }, 1500); // 1.5 секунды паузы — ждём пока сервер точно удалит стол
// }



//   if (!wheel && !cashBar) return;

//   let aborted = false;

//   (async () => {
//     try {
//       // 1) если пришли уже готовые сегменты (редкий кейс) — просто показать
//       if (wheel && Array.isArray(wheel.segments) && wheel.selectedId) {
//         if (aborted) return;
//         setCashWheel({
//           show: true,
//           segments: wheel.segments,
//           selectedId: wheel.selectedId,
//           title: wheel.title || 'Ваш приз',
//           fromServer: true,
//         });
//         return;
//       }

//       // 2) обычный путь: проверяем pending -> крутим roll
//       const authToken =
//         token ||
//         localStorage.getItem('token'); // если проп не прокинули

//       if (!authToken) {
//         console.warn('[CASH] нет токена — показываю fallback-визуал без начислений');
//         const bet   = Number(cashBar?.bet) || 0;
//         const mult  = Number(cashBar?.betMultiplier) || 1;
//         const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
//         const nice  = buildNiceSegments(prize);
//         if (aborted) return;
//         setCashWheel({ show: true, segments: nice.segments, selectedId: nice.selectedId, title: 'Ваш приз',fromServer: false, });
//         return;
//       }

//     const API_BASE =
//       import.meta?.env?.VITE_API_BASE ||
//       process.env.REACT_APP_API_URL + '/api';


//       const headers = {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${authToken}`,
//       };

//       // 2.1) pending?
//       const pendRes = await fetch(`${API_BASE}/fortuneGame/pending`, {
//         method: 'GET',
//         headers,
      
//       });
//       const pendJson = await pendRes.json();
//       if (!pendRes.ok || !pendJson?.pending) {
//         console.warn('[CASH] pending=false — показываю fallback-визуал');
//         const bet   = Number(cashBar?.bet) || 0;
//         const mult  = Number(cashBar?.betMultiplier) || 1;
//         const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
//         const nice  = buildNiceSegments(prize);
//         if (aborted) return;
//         setCashWheel({ show: true, segments: nice.segments, selectedId: nice.selectedId, title: 'Ваш приз',fromServer: false, });
//         return;
//       }

//       // 2.2) roll!
//       const rollRes = await fetch(`${API_BASE}/fortuneGame/roll`, {
//         method: 'POST',
//         headers,
//         body: JSON.stringify({}), // если нужен forceId для тестов — добавь сюда
      
//       });
//       const rollJson = await rollRes.json();
//       if (!rollRes.ok || !rollJson?.ok || !rollJson?.win?.id) {
//         throw new Error(`roll failed: ${rollRes.status}`);
//       }

//       // сервер дал strip (лента) и win.id — Overlay сам докрутит к selectedId
//       const segs = Array.isArray(rollJson.strip) ? rollJson.strip : [];
//       if (aborted) return;
//       setCashWheel({
//         show: true,
//         segments: segs,
//         selectedId: rollJson.win.id,
//         title: 'Ваш приз',
//         fromServer: true,
//       });
//     } catch (e) {
//       console.error('[CASH] ошибка запроса:', e);
//       // крайней случай — красивый fallback
//       const bet   = Number(cashBar?.bet) || 0;
//       const mult  = Number(cashBar?.betMultiplier) || 1;
//       const prize = Number(cashBar?.payout ?? (bet && mult ? bet * mult : 0));
//       const nice  = buildNiceSegments(prize);
//       if (!aborted) {
//         setCashWheel({ show: true, segments: nice.segments, selectedId: nice.selectedId, title: 'Ваш приз',fromServer: false, });
//       }
//     } finally {
//       // очень важно: очищаем history state — иначе эффект сработает снова при back/forward
//       if (!aborted) navigate('.', { replace: true, state: {} });
//     }
//   })();

//   return () => { aborted = true; };
// }, [location.state, navigate, token]);



// useEffect(() => {
//   const payload = location.state?.openCashWheel;
//   if (!payload) return;

//   setCashWheel({
//     show: true,
//     segments: Array.isArray(payload.segments) ? payload.segments : [],
//     selectedId: payload.selectedId ?? null,
//     title: payload.title || 'Ваш приз',
//   });

//   // очищаем history state, чтобы колесо не всплывало снова при навигации назад
//   navigate('.', { replace: true, state: {} });
// }, [location.state, navigate]);


const API_URL = process.env.REACT_APP_API_URL;

useEffect(() => {
  const ratingsUrl = API_URL
    ? `${API_URL}/api/auth/users-with-ratings`
    : '/api/auth/users-with-ratings';

  fetch(ratingsUrl)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Ratings HTTP ${res.status}`);
      }

      return res.json();
    })
    .then(setAllUsers)
    .catch((error) => {
      console.error('[Lobby] users-with-ratings:', error);
    });
}, [API_URL]);

useEffect(() => {
  let cancelled = false;
  let timerId = null;

  const endpoint = API_URL
    ? `${API_URL}/api/player-countries`
    : '/api/player-countries';

  const normalizeCountryCode = (value) => {
    const code = String(value || '')
      .trim()
      .toUpperCase();

    return /^[A-Z]{2}$/.test(code)
      ? code
      : null;
  };

  const readDetectedCountry = () =>
    normalizeCountryCode(
      localStorage.getItem('bgq_country_code')
    );

  const applyCountryList = (list) => {
    if (cancelled || !Array.isArray(list)) {
      return;
    }

    const nextMap = {};

    for (const item of list) {
      const name = String(item?.username || '').trim();
      const code = normalizeCountryCode(
        item?.countryCode || item?.country_code
      );

      if (name && code) {
        nextMap[name] = code;
      }
    }

    setCountryByUsername(nextMap);
  };

  const loadCountries = async () => {
    try {
      const response = await fetch(endpoint);

      if (!response.ok) {
        throw new Error(
          `Player countries HTTP ${response.status}`
        );
      }

      applyCountryList(await response.json());
    } catch (error) {
      if (!cancelled) {
        console.warn(
          '[Lobby] Не удалось загрузить флаги игроков:',
          error
        );
      }
    }
  };

  const saveMyCountry = async (attempt = 0) => {
    if (cancelled || !username) {
      return;
    }

    const authToken =
      token || localStorage.getItem('token');

    if (!authToken) {
      return;
    }

    const countryCode = readDetectedCountry();

    // i18n определяет страну асинхронно. Даём ему
    // до пяти секунд, не выполняя второй geo-запрос.
    if (!countryCode && attempt < 10) {
      timerId = window.setTimeout(
        () => saveMyCountry(attempt + 1),
        500
      );

      return;
    }

    if (!countryCode) {
      return;
    }

    try {
      const response = await fetch(`${endpoint}/me`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify({ countryCode })
      });

      if (!response.ok) {
        throw new Error(
          `Save player country HTTP ${response.status}`
        );
      }

      const saved = await response.json();
      const savedCode = normalizeCountryCode(
        saved?.countryCode || saved?.country_code
      );

      if (!cancelled && savedCode) {
        setCountryByUsername((previous) => ({
          ...previous,
          [username]: savedCode
        }));
      }
    } catch (error) {
      if (!cancelled) {
        console.warn(
          '[Lobby] Не удалось сохранить страну игрока:',
          error
        );
      }
    }
  };

  void loadCountries();
  void saveMyCountry();

  return () => {
    cancelled = true;

    if (timerId !== null) {
      window.clearTimeout(timerId);
    }
  };
}, [API_URL, token, username]);


// восстановить выбор при загрузке
useEffect(() => {
  const saved = localStorage.getItem('lobby.typeGame');
  if (saved !== null) setTypeGame(Number(saved));
}, []);

// сохранять выбор при изменении
useEffect(() => {
  localStorage.setItem('lobby.typeGame', String(typeGame));
}, [typeGame]);


//   useEffect(() => {
//   if (typeGame === 1) {
//     const now = Date.now();
//     if (now - lastLongTablesRequestTimeRef.current > 1500) {
//       lastLongTablesRequestTimeRef.current = now;
//       console.log('[Lobby] Переключение на длинные — запросим LongTables');
//       longSocket.emit('requestLongTables');
//     } else {
//       console.log('[Lobby] Пропущен emit requestLongTables — слишком часто');
//     }
//   }
// }, [typeGame]);



useEffect(() => {
  if (!username) return;
  console.log('[SOCKET] joinUserRoom ->', username);

  const join = () => socket.emit('joinUserRoom', { username });
  if (socket.connected) join();
  socket.on('connect', join);
  return () => socket.off('connect', join);
}, [username]);

// 🔁 АВТО-ВОЗВРАТ НА ДЛИННУЮ ДОСКУ ПОСЛЕ РЕФРЕША / ПЕРЕЗАХОДА
useEffect(() => {
  if (!username) return;

  let cancelled = false;

  const ask = () => {
    if (cancelled) return;

    // вызываем наш новый серверный хендлер в /long namespace
    longSocket.emit('long_getMyActiveTable', (resp) => {
      console.log('[Lobby] long_getMyActiveTable <-', resp);

      if (cancelled || !resp || !resp.ok) return;

      const tid = resp.tableId ?? resp.table_id ?? resp.id;
      if (!tid) return;

      // 👉 Здесь и есть "реконнект": уходим сразу на длинную доску
      navigate(`/longGame/${tid}`, { replace: true });
    });
  };

  if (longSocket.connected) {
    // уже подключён к /long — сразу спрашиваем
    ask();
  } else {
    // подключится позже — спросим в момент connect
    longSocket.once('connect', ask);
  }

  return () => {
    cancelled = true;
    // снимем handler на всякий случай
    longSocket.off('connect', ask) 
  };
}, [username, navigate]);






// 🔁 ФОЛЛБЕК: если сервер не знает стол, но в localStorage есть currentTableId
// useEffect(() => {
//   if (!username) return;

//   let cancelled = false;

//   const t = setTimeout(() => {
//     if (cancelled) return;

//     const rawId    = localStorage.getItem('currentTableId');
//     const gameType = localStorage.getItem('gameType'); // 'short' | 'long'

//     if (!rawId || !gameType) return;

//     const tableId = Number(rawId);
//     if (!Number.isFinite(tableId)) return;

//     if (gameType === 'short') {
//       navigate(`/ShortBackgammonBoard/${tableId}`, { replace: true });
//     } else if (gameType === 'long') {
//       navigate(`/longGame/${tableId}`, { replace: true });
//     }
//   }, 800);

//   return () => {
//     cancelled = true;
//     clearTimeout(t);
//   };
// }, [username, navigate]);


// 🔁 ФОЛЛБЕК: если сервер не знает стол, но в localStorage есть currentTableId
// useEffect(() => {
//   if (!username) return;

//   let cancelled = false;

//   // чуть ждём, вдруг серверный short_getMyActiveTable сам всё сделает
//   const t = setTimeout(() => {
//     if (cancelled) return;

//     const rawId   = localStorage.getItem('currentTableId');
//     const gameType = localStorage.getItem('gameType'); // 'short' | 'long'

//     const role     = localStorage.getItem('sessionRole'); // <-- НОВОЕ

//     if (!rawId || !gameType) return;

//     const tableId = Number(rawId);
//     if (!Number.isFinite(tableId)) return;

//     if (gameType === 'short') {
//       navigate(`/ShortBackgammonBoard/${tableId}`, { replace: true });
//     } else if (gameType === 'long') {
//       navigate(`/longGame/${tableId}`, { replace: true });
//     }
//   }, 800); // 0.8 сек — чтобы у сервера был шанс ответить

//   return () => {
//     cancelled = true;
//     clearTimeout(t);
//   };
// }, [username, navigate]);


// 🔁 АВТО-ВОЗВРАТ НА КОРОТКУЮ ДОСКУ ПОСЛЕ ОБНОВЛЕНИЯ / ПЕРЕЗАХОДА
useEffect(() => {
  if (!username) return;

  let cancelled = false;

  const ask = () => {
    if (cancelled) return;

    // вызываем наш новый серверный хендлер
    socket.emit('short_getMyActiveTable', (resp) => {
      console.log('[Lobby] short_getMyActiveTable <-', resp);

      if (cancelled || !resp || !resp.ok) return;

      const tid = resp.tableId ?? resp.table_id ?? resp.id;
      if (!tid) return;

      // 👉 тут и есть "реконнект": просто уходим сразу на доску
      navigate(`/ShortBackgammonBoard/${tid}`, { replace: true });
    });
  };

  if (socket.connected) {
    ask();
  } else {
    socket.once('connect', ask);
  }

  return () => {
    cancelled = true;
    socket.off('connect', ask);
  };
}, [username, navigate]);






useEffect(() => {
  const onUserBalance = ({ balance }) => {
    console.log('[Lobby] userBalance <-', balance);
    setBalance(balance);

    // 👉 пробрасываем наверх, чтобы App обновил userBalance (Header видит именно его)
    window.dispatchEvent(new CustomEvent('balance-updated', {
      detail: { balance, source: 'socket', allowDecrease: true }
    }));
  };

  socket.on('userBalance', onUserBalance);
  socket.on('userAssets', ({ tickets, skins }) => { /* ... */ });

  return () => {
    socket.off('userBalance', onUserBalance);
    socket.off('userAssets');
  };
}, [setBalance]);


//   useEffect(() => {
//     socket.on('userBalance', ({ balance }) => {
//       setBalance(balance);
//     });
//     socket.on('userAssets', ({ tickets, skins }) => {
//   console.log('[SOCKET] userAssets:', { tickets, skins });
//   // если есть сеттеры — раскомментируй:
//   // setTickets?.(tickets);
//   // setSkins?.(skins);
// });

//     return () => {
//       socket.off('userBalance');
//       socket.off('userAssets');

//     };
//   }, [setBalance]);


// useEffect(() => {
//   const onAssets = ({ tickets, skins }) => {
//     if (tickets) setTickets(tickets);
//     if (skins)   setSkins(skins);
//   };
//   socket.on('userAssets', onAssets);
//   return () => socket.off('userAssets', onAssets);
// }, [setTickets, setSkins]);





  useEffect(() => {
  if (!username) return;

  const handleConnect = () => {
    longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
      if (resp?.tableId) {
        navigate(`/long-tournament/table?tableId=${resp.tableId}`);
      }
    });
  };

  if (longTournamentSocket.connected) {
    handleConnect(); // уже подключён — вызываем сразу
  } else {
    longTournamentSocket.once('connect', handleConnect); // подключится позже
  }

  return () => {
    longTournamentSocket.off('connect', handleConnect); // очистка
  };
}, [username, navigate]);

// Много спамит от этого сервер ложится но пробую над ним заменить, надеюсь багов не будет пока в режиме теста
// useEffect(() => {
//   if (!username) return;
//   if (!longTournamentSocket.connected) return;

//   longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
//     if (resp?.tableId) {
//       navigate(`/long-tournament/table?tableId=${resp.tableId}`);
//     }
//   });
// }, [username]);


  // =========================================
  // 2) Запрос турниров (если нужен)
  // =========================================
  // useEffect(() => {
  //   socket.on('responseAllTournaments', (data) => {
  //     setActiveTournaments(data.activeTournaments || []);
  //   });
  //   // socket.emit('requestAllTournaments');

  //   return () => {
  //     socket.off('responseAllTournaments');
  //   };
  // }, []);

  // =========================================
  // 3) Запрашиваем списки столов (коротких + длинных)
  // =========================================
  // useEffect(() => {
  //   // 3.1) КОРОТКИЕ (через socket)
  //   socket.emit('requestTables');
  //   socket.on('tablesList', (tablesData) => {
  //     setTables(tablesData);
  //   });

  //   // 3.2) ДЛИННЫЕ (через longSocket)
  //   // Подключаемся, если не autoConnect
  //   if (!longSocket.connected) {
  //     longSocket.connect();
  //   }
  //   longSocket.emit('requestLongTables');
   
    


  //   return () => {
  //     socket.off('tablesList');
    
  //   };
  // }, [setTables, setTablesLong]);

// useEffect(() => {
//   if (tablesLong.length === 0) {
//     console.log('🔁 Повторный запрос списка длинных столов');
//     longSocket.emit('requestLongTables');
//   }
// }, [tablesLong]);




// === КОРОТКИЙ ТУРНИР: автопереход к активному столу после refresh ===
useEffect(() => {
  if (!username) return;

  let cancelled = false;
  let watchdog = null;
  let retried = false;

  const cleanup = () => {
    if (watchdog) { clearTimeout(watchdog); watchdog = null; }
    tournamentSocket.off('connect', afterConnect);
    tournamentSocket.io?.off('reconnect', onReconnect);
  };

  const navigateTo = (tableId) => {
    if (cancelled) return;
    cleanup();
    if (tableId) {
      navigate(`/tournament/table?tableId=${tableId}`, { replace: true });
    }
  };

  const askActiveTable = () => {
    if (cancelled) return;
    // !!! замени имя события на своё серверное
    tournamentSocket.emit('short_getMyActiveTable', (resp) => {
      // ожидаем формата { ok: true, tableId } или { tableId }
      const tid = resp?.tableId ?? resp?.id;
      if (tid) navigateTo(tid);
    });

    // watchdog + 1 повтор
    if (watchdog) clearTimeout(watchdog);
    watchdog = setTimeout(() => {
      if (cancelled) return;
      if (!retried) {
        retried = true;
        askActiveTable();
      }
    }, 1200);
  };

  const afterConnect = () => {
    // на всякий случай войти в лобби турниров short
    tournamentSocket.emit('joinShortTournamentLobby', () => {});
    askActiveTable();
  };

  const onReconnect = () => {
    retried = false;
    afterConnect();
  };

  if (tournamentSocket.connected) afterConnect();
  else {
    tournamentSocket.connect();
    tournamentSocket.once('connect', afterConnect);
  }

  tournamentSocket.io?.on('reconnect', onReconnect);

  return () => {
    cancelled = true;
    cleanup();
  };
}, [username, navigate]);













useEffect(() => {
  let cancelled = false;

  const ask = () => {
    if (cancelled) return;
    longSocket.emit('fetchTournaments'); // ← твоё событие для запроса турниров
  };

  if (longSocket.connected) {
    ask();
  } else {
    longSocket.once('connect', ask);
  }

  // подстраховка: если за 400мс не пришёл ответ — повторим запрос
  const retry = setTimeout(() => {
    if (!cancelled) longSocket.emit('fetchTournaments');
  }, 400);

  return () => {
    cancelled = true;
    clearTimeout(retry);
    longSocket.off('connect', ask);
  };
}, []);








// ---- SHORT LOBBY: один-единственный эффект ----
useEffect(() => {
  let unmounted = false;

  // const onList = (data) => {
  //   console.log('[SHORT PUSH] tablesList ->', data?.length);
  //   if (!unmounted) setTables(Array.isArray(data) ? data : []);
  // };
 const onList = (data) => {
  const arr = Array.isArray(data) ? data : [];

  // если в списке есть finished — запомним id навсегда (чтобы не вернулся)
  const finishedIds = finishedShortTableIdsRef.current;
  for (const t of arr) {
    if (t?.id && isHiddenLobbyStatus(t.status)) {
      finishedIds.add(t.id);
    }
  }

  setTables(filterVisibleTables(arr));
};


   const onUpsert = (tbl) => {
    if (!tbl?.id) return;

    const st = normStatus(tbl.status);


    console.log('[SHORT PUSH] upsert <-', {
  id: tbl?.id,
  status: tbl?.status,
  st: normStatus(tbl?.status),
  p1: tbl?.player1_name,
  p2: tbl?.player2_name,
  hiddenAlready: finishedShortTableIdsRef.current.has(tbl?.id),
});


    // 1) если стол finished/closed — запоминаем и удаляем из state
    if (st === 'finished' || st === 'closed') {
      finishedShortTableIdsRef.current.add(tbl.id);
      setTables(prev => prev.filter(t => t.id !== tbl.id));
      return;
    }

    // 2) если этот id уже помечен как finished — НЕ ДАЁМ ЕМУ ВЕРНУТЬСЯ
    if (finishedShortTableIdsRef.current.has(tbl.id)) {
      return;
    }

    // 3) обычный upsert
    setTables(prev => {
      const i = prev.findIndex(t => t.id === tbl.id);
      if (i === -1) return [...prev, tbl];
      const copy = prev.slice();
      copy[i] = { ...copy[i], ...tbl };
      return copy;
    });
  };

  const onDeleted = ({ tableId }) => {
    console.log('[SHORT PUSH] tableDeleted ->', tableId);
    setTables(prev => prev.filter(t => t.id !== tableId));
  };

  // сначала уберём возможные старые хендлеры,
  // чтобы при повторных маунтах не размножать слушатели
  socket.off('tablesList');
  socket.off('tableUpdated');
  socket.off('tableDeleted');
  socket.off('shortTableUpsert');

  socket.on('tablesList', onList);
  socket.on('tableUpdated', onUpsert);
  socket.on('tableDeleted', onDeleted);
  socket.on('shortTableUpsert', onUpsert);

  const pullSnapshot = () => {
    console.log('[SHORT ACK] requestTables');
  socket.emit('requestTables', (fresh) => {
  setTables(filterVisibleTables(fresh));
});

  };

  const joinShortLobby = () => {
    // пробуем оба имени комнаты — одно из них точно есть на сервере
    console.log('[SHORT] join room(s)…');
    socket.emit('joinShortLobby', (ack) => console.log('[SHORT ACK] joinShortLobby ->', ack));
    socket.emit('joinLobby',      (ack) => console.log('[SHORT ACK] joinLobby ->', ack));
    // сразу просим снимок
    pullSnapshot();
  };

  const afterConnect = () => {
    console.log('[SHORT] connected; id=', socket.id);
    joinShortLobby();
  };

  if (socket.connected) afterConnect();
  else {
    socket.connect();
    socket.once('connect', afterConnect);
  }

  // на реконнекте снова зайдём в комнату и спросим снимок
  const onReconnect = () => {
    console.log('[SHORT] reconnect');
    joinShortLobby();
  };
  socket.on('reconnect', onReconnect);

  return () => {
    unmounted = true;
    socket.off('tablesList', onList);
    socket.off('tableUpdated', onUpsert);
    socket.off('tableDeleted', onDeleted);
    socket.off('reconnect', onReconnect);
    socket.off('connect', afterConnect);
    socket.off('shortTableUpsert', onUpsert);

  };
}, [setTables]);





















// ⬇️ ДОБАВЬ этот эффект один раз
useEffect(() => {
  let unmounted = false;

  const pullSnapshot = () => {
    // ACK-ответ со снапшотом (на сервере: callback(list))
    longSocket.emit('requestLongTables', (list) => {
      if (unmounted) return;
      setTablesLong(Array.isArray(list) ? list : []);
    });
  };

  const onList = (list) => {
    setTablesLong(Array.isArray(list) ? list : []);
  };

  const onUpsert = (tbl) => {
    setTablesLong(prev => {
      const i = prev.findIndex(t => t.id === tbl.id);
      if (i === -1) return [...prev, tbl];
      const copy = prev.slice();
      copy[i] = { ...copy[i], ...tbl };
      return copy;
    });
  };

  const onDeleted = ({ tableId }) => {
    setTablesLong(prev => prev.filter(t => t.id !== tableId));
  };

  // подписки
  longSocket.on('longTablesList', onList);
  longSocket.on('longTableCreated', onUpsert);
  longSocket.on('longTableUpdated', onUpsert);
  longSocket.on('longTableDeleted', onDeleted);

  // коннект + первый снимок
  const afterConnect = () => {
    // если есть комнаты — войдём; если нет, просто проигнорится на сервере
    longSocket.emit('joinLongLobby');
    pullSnapshot();
  };

  if (longSocket.connected) {
    afterConnect();
  } else {
    longSocket.connect();
    longSocket.once('connect', afterConnect);
  }

  return () => {
    unmounted = true;
    longSocket.off('longTablesList', onList);
    longSocket.off('longTableCreated', onUpsert);
    longSocket.off('longTableUpdated', onUpsert);
    longSocket.off('longTableDeleted', onDeleted);
    longSocket.off('connect', afterConnect);
  };
}, [setTablesLong]);



useEffect(() => {
  let unmounted = false;

  const pullSnapshot = () => {
    khachapuriSocket.emit('requestKhachapuriTables', (list) => {
      if (unmounted) return;
      setTablesKhachapuri(Array.isArray(list) ? list : []);
    });
  };

  const onList = (list) => {
    setTablesKhachapuri(Array.isArray(list) ? list : []);
  };

  const onUpsert = (tbl) => {
    setTablesKhachapuri((prev) => {
      const i = prev.findIndex((t) => t.id === tbl.id);
      if (i === -1) return [...prev, tbl];
      const copy = prev.slice();
      copy[i] = { ...copy[i], ...tbl };
      return copy;
    });
  };

  const onDeleted = ({ tableId }) => {
    setTablesKhachapuri((prev) => prev.filter((t) => t.id !== tableId));
  };

  khachapuriSocket.on('khachapuriTablesList', onList);
  khachapuriSocket.on('khachapuriTableCreated', onUpsert);
  khachapuriSocket.on('khachapuriTableUpdated', onUpsert);
  khachapuriSocket.on('khachapuriTableDeleted', onDeleted);

  const afterConnect = () => {
    khachapuriSocket.emit('joinKhachapuriLobby');
    pullSnapshot();
  };

  if (khachapuriSocket.connected) {
    afterConnect();
  } else {
    try {
      const token = localStorage.getItem('token');
      khachapuriSocket.auth = token ? { token } : {};
    } catch (e) {}

    khachapuriSocket.connect();
    khachapuriSocket.once('connect', afterConnect);
  }

  return () => {
    unmounted = true;
    khachapuriSocket.off('khachapuriTablesList', onList);
    khachapuriSocket.off('khachapuriTableCreated', onUpsert);
    khachapuriSocket.off('khachapuriTableUpdated', onUpsert);
    khachapuriSocket.off('khachapuriTableDeleted', onDeleted);
    khachapuriSocket.off('connect', afterConnect);
  };
}, [setTablesKhachapuri]);


useEffect(() => {
 const onJoinErr = (payload) => {
    // серверный текст ошибки
    const msg = String(payload?.message || '');

    // ✅ если стол уже удалён — это ожидаемо, не пугаем игрока алертом
    if (msg.toLowerCase().includes('стол не найден')) {
      try {
        localStorage.removeItem('currentTableId');
        localStorage.removeItem('gameType');
      } catch {}

      // можно мягко освежить списки
      // (если не хочешь — можешь удалить эти две строки)
      setTimeout(() => {
        refreshShortTables();
        refreshLongTables();
      }, 300);

      return; // ⛔ без alert
    }

    // иначе оставляем старое поведение
    if (payload?.balance !== undefined) {
      const b = Number(payload.balance);
      if (Number.isFinite(b)) setBalance(b);
    }

    alert(msg || 'Не удалось войти за стол');
  };

  socket.on('joinTable_error', onJoinErr);
  return () => socket.off('joinTable_error', onJoinErr);
}, [setBalance]); // как у тебя было






// ==== SHORT LOBBY: единый эффект (вместо двух удалённых) ====
// useEffect(() => {
//   let unmounted = false;

//   const onList = (data) => {
//     console.log('[SHORT PUSH] tablesList ->', Array.isArray(data) ? data.length : data);
//     if (!unmounted) setTables(Array.isArray(data) ? data : []);
//   };
//   const onUpsert = (tbl) => {
//     console.log('[SHORT PUSH] tableUpdated ->', tbl?.id);
//     setTables(prev => {
//       const i = prev.findIndex(t => t.id === tbl.id);
//       if (i === -1) return [...prev, tbl];
//       const copy = prev.slice();
//       copy[i] = { ...copy[i], ...tbl };
//       return copy;
//     });
//   };
//   const onDeleted = ({ tableId }) => {
//     console.log('[SHORT PUSH] tableDeleted ->', tableId);
//     setTables(prev => prev.filter(t => t.id !== tableId));
//   };

//   // очистим возможные старые слушатели
//   socket.off('tablesList');
//   socket.off('tableUpdated');
//   socket.off('tableDeleted');

//   socket.on('tablesList', onList);
//   socket.on('tableUpdated', onUpsert);
//   socket.on('tableDeleted', onDeleted);

//   const pullSnapshot = () => {
//     console.log('[SHORT ACK] requestTables');
//     socket.emit('requestTables', (fresh) => {
//       console.log('[SHORT ACK] fresh length =', Array.isArray(fresh) ? fresh.length : 'bad');
//       if (!unmounted) setTables(Array.isArray(fresh) ? fresh : []);
//     });
//   };





 


//   const joinShortLobby = () => {
//     console.log('[SHORT] join room(s)…');
//     // пробуем оба имени — одно из них точно есть на сервере
//     socket.emit('joinShortLobby', (ack) => console.log('[SHORT ACK] joinShortLobby ->', ack));
//     socket.emit('joinLobby',      (ack) => console.log('[SHORT ACK] joinLobby ->', ack));
//     pullSnapshot();
//   };

//   const afterConnect = () => {
//     console.log('[SHORT] connected; id=', socket.id);
//     joinShortLobby();
//   };

//   if (socket.connected) afterConnect();
//   else {
//     socket.connect();
//     socket.once('connect', afterConnect);
//   }

//   // ВАЖНО: использовать менеджер для реконнекта
//   const onReconnect = () => {
//     console.log('[SHORT] manager reconnect');
//     joinShortLobby();
//   };
//   socket.io.on('reconnect', onReconnect);

//   return () => {
//     unmounted = true;
//     socket.off('tablesList', onList);
//     socket.off('tableUpdated', onUpsert);
//     socket.off('tableDeleted', onDeleted);
//     socket.io.off('reconnect', onReconnect);
//     socket.off('connect', afterConnect);
//   };
// }, [setTables]);



const joinTable = async (tableId) => {

  // 1) Проверяем, что пользователь авторизован
  if (!username) {
    alert('Сначала авторизуйтесь!');
    return;
  }

  // 2) Находим стол по id
  const table = tables.find((t) => t.id === tableId);
  if (!table) {
    alert('Стол не найден');
    return;
  }

  // 3) КЛИЕНТСКАЯ проверка баланса
// 3) КЛИЕНТСКАЯ проверка баланса (но сначала подтянем свежий)
const fresh = await requestFreshBalance();

// если свежий не пришёл — используем то, что есть в состоянии
const currentBalance = Number.isFinite(fresh) ? fresh : Number(balance);

// 1) initial_bet
const initial = Number(table?.initial_bet);

// 2) max_bet (может быть null/undefined)
const max = table?.max_bet != null ? Number(table.max_bet) : NaN;

// 3) что требуем для входа: max_bet, если он валидный, иначе initial_bet
// (и на всякий случай не даём max быть меньше initial)
const needed = (() => {
  const initOk = Number.isFinite(initial) ? initial : NaN;
  const maxOk  = Number.isFinite(max) ? max : NaN;

  if (Number.isFinite(maxOk) && maxOk > 0) {
    if (Number.isFinite(initOk)) return Math.max(initOk, maxOk);
    return maxOk;
  }
  return initOk;
})();

if (!Number.isFinite(currentBalance)) {
  alert('Баланс ещё загружается. Подождите 1–2 секунды и попробуйте снова.');
  return;
}

if (!Number.isFinite(needed)) {
  alert('Не удалось определить ставку стола. Обновите страницу и попробуйте снова.');
  return;
}

if (currentBalance < needed) {
  // более понятное сообщение: хватает на initial, но не хватает на max
  const initText = Number.isFinite(initial) ? `$${initial}` : '—';
  const maxText  = Number.isFinite(max) ? `$${max}` : '—';

  alert(
    `Недостаточно баланса для этого стола.\n` +
    `Минимум для входа по макс. ставке: $${needed}\n` +
    `Ставки стола: ${initText} / ${maxText}`
  );
  return;
}

// const fresh = await requestFreshBalance();

// // если свежий не пришёл — используем то, что есть в состоянии
// const currentBalance = Number.isFinite(fresh) ? fresh : Number(balance);

// // ⚠️ важно: сервер у тебя проверяет initial_bet, а НЕ max_bet
// const needed = Number(table.initial_bet);

// if (!Number.isFinite(currentBalance)) {
//   alert('Баланс ещё загружается. Подождите 1–2 секунды и попробуйте снова.');
//   return;
// }

// if (currentBalance < needed) {
//   alert(`Недостаточно баланса для участия. Требуется минимум $${needed}.`);
//   return;
// }


  // 4) Отключаем броски (как у тебя и было)
  setRollEnabled(false);

  // 5) Сохраняем параметры стола в localStorage (как раньше)
  // localStorage.setItem('currentTableId', String(tableId));
  const base = Number(table.initial_bet) || 1;
    localStorage.setItem('gameType', 'short');
  // const max  = table.max_bet != null ? Number(table.max_bet) : null;





  try {
    localStorage.setItem(
      `stake:short:${tableId}`,
      JSON.stringify({ base, max, updatedAt: Date.now() })
    );
  } catch {}

    // 5.1) Сохраняем имена игроков стола для BoardDisplay
  try {
    const playersPayload = {
      white: {
        // player1_name — это тот, кто сидит слева в лобби
        username: table.player1_name || '',
        // если сервер отдаёт аватар, подставь сюда:
        // avatar: table.player1_avatar || null,
        avatar: null,
      },
      black: {
        // player2_name — тот, кто справа
        username: table.player2_name || '',
        // avatar: table.player2_avatar || null,
        avatar: null,
      },
    };

    // ключ, который читает BoardDisplay: short:players:<tableId>
    localStorage.setItem(
      `short:players:${tableId}`,
      JSON.stringify(playersPayload)
    );

    // даём сигнал всем, кто подписан на short:players-changed
    window.dispatchEvent(
      new CustomEvent('short:players-changed', {
        detail: { tableId },
      })
    );
  } catch (e) {
    console.warn('[short:players] save error', e);
  }

  // 6) СРАЗУ идём на доску — КАК В ТВОЁМ СТАРОМ КОДЕ
  // это важно: доска успеет навесить слушатели, и шашки не будут пустыми
  navigate(`/ShortBackgammonBoard/${tableId}`);

  // 7) Отправляем joinTable на сервер (ровно как в твоём старом варианте)
  const go = () => {
    socket.emit('joinTable', { tableId, player: username });

    try {
      // сброс кубиков/визуала, как у тебя
      window.dispatchEvent(new CustomEvent('short:reset-dice'));
      sessionStorage.setItem(
        'short:lastJoin',
        JSON.stringify({ tableId, ts: Date.now() })
      );
    } catch {}

    // ⛔ никакого navigate здесь — он уже был выше
  };

  // 8) Гарантируем подключение сокета
  if (!socket.connected) {
    socket.connect();
    socket.once('connect', go);
  } else {
    go();
  }
};


// const joinTable = (tableId) => {
//   if (!username) {
//     alert('Сначала авторизуйтесь!');
//     return;
//   }

//   const table = tables.find((t) => t.id === tableId);
//   if (!table) {
//     alert('Стол не найден');
//     return;
//   }

//   setRollEnabled(false);

//   // сохраняем параметры стола
//   localStorage.setItem('currentTableId', String(tableId));
//   const base = Number(table.initial_bet) || 1;
//   const max  = table.max_bet != null ? Number(table.max_bet) : null;
//   try {
//     localStorage.setItem(
//       `stake:short:${tableId}`,
//       JSON.stringify({ base, max, updatedAt: Date.now() })
//     );
//   } catch {}

//   // один раз получаем роль/цвет от сервера
// //  socket.off('short:youAre');
// // socket.once('short:youAre', ({ role, color, playerId, tableId: serverTableId }) => {
//   // const finalTableId = serverTableId || tableId; // на случай, если сервер пришлёт свой id

//   // try {
//   //   localStorage.setItem(
//   //     'short:youAre',
//   //     JSON.stringify({ tableId: finalTableId, role, color, playerId, ts: Date.now() })
//   //   );
//   // } catch {}

//   // 👉 Переходим на доску ТОЛЬКО после успешного ответа от сервера
//   navigate(`/ShortBackgammonBoard/${tableId}`);



//   const go = () => {
//   socket.emit('joinTable', { tableId, player: username });

//   try {
//     window.dispatchEvent(new CustomEvent('short:reset-dice'));
//     sessionStorage.setItem('short:lastJoin', JSON.stringify({ tableId, ts: Date.now() }));
//   } catch {}

//   // ⛔ НИКУДА не переходим здесь
//   // ждём short:youAre или notEnoughBalance
// };


//   if (!socket.connected) {
//     socket.connect();
//     socket.once('connect', go); 
//   } else {
//     go();
//   }
// };


// useEffect(() => {
//   const onNotEnough = ({ required, balance }) => {
//     // balance можно и не показывать, если не хочешь
//     alert(`Недостаточно баланса для участия. Требуется минимум $${required}.`);
//   };

//   socket.on('notEnoughBalance', onNotEnough);
//   return () => {
//     socket.off('notEnoughBalance', onNotEnough);
//   };
// }, []);

//   const joinTable = (tableId) => {
//   if (!username) {
//     alert('Сначала авторизуйтесь!');
//     return;
//   }

//   // Найти стол
//   const table = tables.find((t) => t.id === tableId);
//   if (!table) {
//     alert('Стол не найден');
//     return;
//   }

//   // Проверка баланса vs maxBet (если max_bet нет — берём initial_bet)
//   const currentBalance = Number(balance);
//   const maxBet = Number(table.max_bet ?? table.initial_bet);
//   if (!Number.isFinite(currentBalance) || currentBalance < maxBet) {
//     alert(`Недостаточно баланса для участия. Требуется минимум $${maxBet},Если баланса достаточно, просто обновите страницу!`);
//     return;
//   }

//   setRollEnabled(false);

//   // Сохраняем локальные параметры стола (используются на борде)
//   localStorage.setItem('currentTableId', String(tableId));
//   const base = Number(table.initial_bet) || 1;
//   const max  = table.max_bet != null ? Number(table.max_bet) : null;
//   try {
//     localStorage.setItem(
//       `stake:short:${tableId}`,
//       JSON.stringify({ base, max, updatedAt: Date.now() })
//     );
//   } catch {}

//   // Сначала ставим одноразовый слушатель роли/цвета от сервера
//   socket.off('short:youAre');
//   socket.once('short:youAre', ({ role, color, playerId }) => {
//     try {
//       localStorage.setItem(
//         'short:youAre',
//         JSON.stringify({ tableId, role, color, playerId, ts: Date.now() })
//       );
//     } catch {}
//   });

//   // Эмит joinTable и переход на борт
//   const go = () => {

    
//     socket.emit('joinTable', { tableId, player: username });
//       // ❶ ДО navigate — общий сброс визуала кубиков и прочего
//   try {
//     window.dispatchEvent(new CustomEvent('short:reset-dice'));
//     sessionStorage.setItem('short:lastJoin', JSON.stringify({ tableId, ts: Date.now() }));
//   } catch {}
//     // Переходим один раз (без дублей ниже)
//     navigate(`/ShortBackgammonBoard/${tableId}`);
//   };

//   if (!socket.connected) {
//     socket.connect();
//     socket.once('connect', go);
//   } else {
//     go();
//   }
// };


  // =========================================
  // 5) Функция для входа (длинные)
  // =========================================
  let currentTableId1 = null;
  // ⬇️ ВСТАВИТЕ/ЗАМЕНИТЕ целиком
const joinLongTable = async (longTableIdStart) => {
  if (!username) return alert('Сначала авторизуйтесь!');
  if (isJoiningRef.current) return;       // защита от дабл-кликов
  isJoiningRef.current = true;

  const release = () => { isJoiningRef.current = false; };

  // 0) Проверка, что такой стол вообще в списке
  const table = tablesLong.find(t => t.id === longTableIdStart);
  if (!table) { release(); return alert('Long-стол не найден'); }

  // 1) гарантия подключения
  const ensureLongConnected = () =>
    new Promise((res) => {
      if (longSocket.connected) return res();
      longSocket.connect();
      longSocket.once('connect', res);
    });

  // 2) одно место храним текущий id (м.б. изменится из-за редиректа)
  let currentId = longTableIdStart;

  // 3) Общая отписка обработчиков
  let watchdog = null;
  const onSuccess = (payload) => {
    // может прийти как { tableId, ... } или просто число
    const okId = payload?.tableId ?? currentId;

    cleanup();
    release();

    // 🔴 ВАЖНО: фиксация роли ИГРОКА и параметров стола
    try {
      // помечаем, что теперь мы игрок, а не observer
   

      // чтобы фоллбэк и реконнект знали, куда возвращать
      // localStorage.setItem('currentTableId', String(okId));
      localStorage.removeItem('longBotTest');
      localStorage.setItem('gameType', 'long');

      // ставка для длинного стола (по аналогии с short)
      const base = Number(table.initial_bet) || 1;
      const max  = table.max_bet != null ? Number(table.max_bet) : null;

      localStorage.setItem(
        `stake:long:${okId}`,
        JSON.stringify({ base, max, updatedAt: Date.now() })
      );
    } catch (e) {
      console.warn('[LONG] localStorage error', e);
    }

    // после успешной проверки баланса — реально заходим за стол
    longSocket.emit("joinLongTable", {
      longTableId: okId,
      playerUsername: username
    });

    setRollEnabled(false);
    navigate(`/longGame/${okId}`);
  };

  const onFail = (msg) => {
    cleanup();
    release();
    alert(msg || 'Не удалось присоединиться');
  };
  const onRedirect = ({ from, to }) => {
    // мягкий редирект сервером: обновляем id и повторяем check
    currentId = to;
    // повторно зовём check, без повторной подписки хэндлеров (они уже стоят once)
    emitCheck(/* retry */ false);
  };
  const onLobbyRedirect = ({ from, to }) => {
    // на всякий случай: сервер в joinLongTable тоже шлёт long_redirectToTable
    currentId = to;
    longSocket.emit("checkBalanceForLongTable", { tableId: currentId, username });
  };

  const cleanup = () => {
    if (watchdog) { clearTimeout(watchdog); watchdog = null; }
    longSocket.off('checkBalanceSuccess', onSuccess);
    longSocket.off('checkBalanceFailed', onFail);
    longSocket.off('checkBalanceRedirect', onRedirect);
    longSocket.off('long_redirectToTable', onLobbyRedirect);
  };

  // 4) Повторная попытка при первом таймауте
  let triedRetry = false;

  const armWatchdog = () => {
    if (watchdog) clearTimeout(watchdog);
    watchdog = setTimeout(() => {
      if (!triedRetry) {
        triedRetry = true;
        // ⚠️ первый таймаут — делаем ровно одну повторную отправку
        emitCheck(/* retry */ true);
        return;
      }
      // второй таймаут — сдаёмся
      onFail('Сервер не ответил. Попробуйте ещё раз.');
    }, 7000); // было 4000 — делаем реалистичнее для сети/БД
  };

  const emitCheck = async (isRetry) => {
    // на всякий случай — если в момент повторной отправки связь отвалилась
    await ensureLongConnected();
    // пере-арм таймера под каждую попытку
    armWatchdog();
    // ⚠️ emit после установки всех once-обработчиков
    longSocket.emit('checkBalanceForLongTable', { tableId: currentId, username });
    if (isRetry) {
      console.warn('[LONG] retry checkBalanceForLongTable', { currentId, username });
    } else {
      console.log('[LONG] emit checkBalanceForLongTable', { currentId, username });
    }
  };

  try {
    await ensureLongConnected();

    // Ставим одноразовые обработчики ДО первого emit
    longSocket.once('checkBalanceSuccess', onSuccess);
    longSocket.once('checkBalanceFailed', onFail);
    longSocket.once('checkBalanceRedirect', onRedirect);
    longSocket.once('long_redirectToTable', onLobbyRedirect);

    // Первая попытка
    await emitCheck(/* retry */ false);
  } catch (e) {
    cleanup();
    release();
    console.warn('[LONG] fatal joinLongTable error:', e);
    alert('Ошибка соединения. Попробуйте ещё раз.');
  }
};



const joinKhachapuriTable = async (tableId) => {
  if (!username) {
    alert('Сначала авторизуйтесь!');
    return;
  }

  if (isJoiningRef.current) return;
  isJoiningRef.current = true;

  const release = () => { isJoiningRef.current = false; };
  const table = tablesKhachapuri.find((t) => Number(t.id) === Number(tableId));

  if (!table) {
    release();
    alert('Стол Хачапури не найден');
    return;
  }

  const go = () => {
    khachapuriSocket.emit(
      'joinKhachapuriTable',
      {
        tableId: Number(tableId),
        playerUsername: username,
        isSpectator: false,

        // Lobby только резервирует место.
        // Стартовый бросок запускаем уже после перехода на Khachapuri.jsx,
        // когда socket-listeners Player 2 гарантированно смонтированы.
        deferStart: true,
      },
      (ack = {}) => {
        release();

        if (!ack.ok) {
          alert(ack.message || 'Не удалось войти за стол Хачапури');
          return;
        }

        const finalTableId = Number(ack.tableId || tableId);

        try {
          localStorage.setItem('gameType', 'khachapuri');
          localStorage.setItem('lobbyCashTab', 'khachapuri');
          const base = Number(table.initial_bet) || 1;
          const max = table.max_bet != null ? Number(table.max_bet) : null;
          localStorage.setItem(
            `stake:khachapuri:${finalTableId}`,
            JSON.stringify({ base, max, updatedAt: Date.now() })
          );
        } catch (e) {}

        rememberKhachapuriRoom(finalTableId, username, false);
        navigate(`/khachapuriGame/${finalTableId}`);
      }
    );
  };

  if (khachapuriSocket.connected) {
    go();
    return;
  }

  try {
    const token = localStorage.getItem('token');
    khachapuriSocket.auth = token ? { token } : {};
  } catch (e) {}

  khachapuriSocket.connect();
  khachapuriSocket.once('connect', go);
};

const watchKhachapuriTable = (tableId) => {
  if (!username) {
    alert('Сначала авторизуйтесь!');
    return;
  }

  const go = () => {
    khachapuriSocket.emit(
      'joinKhachapuriTable',
      { tableId: Number(tableId), playerUsername: username, isSpectator: true },
      (ack = {}) => {
        if (!ack.ok) {
          alert(ack.message || 'Не удалось открыть стол Хачапури');
          return;
        }
        navigate(`/khachapuriGame/${Number(tableId)}?spectator=1`);
      }
    );
  };

  if (khachapuriSocket.connected) {
    go();
    return;
  }

  try {
    const token = localStorage.getItem('token');
    khachapuriSocket.auth = token ? { token } : {};
  } catch (e) {}

  khachapuriSocket.connect();
  khachapuriSocket.once('connect', go);
};






  const requestFreshBalance = useCallback(() => {
  return new Promise((resolve) => {
    if (!username) return resolve(null);

    const onBal = ({ balance }) => {
      socket.off('userBalance', onBal);

      const num = Number(balance);
      if (Number.isFinite(num)) {
        setBalance(num);
      }

      resolve(num);
    };

    // одноразово ждём ответ
    socket.on('userBalance', onBal);

    const emitReq = () => socket.emit('getUserBalance'); // сервер сам знает юзера по токену

    if (socket.connected) {
      emitReq();
    } else {
      socket.connect();
      socket.once('connect', emitReq);
    }

    // защита от "вечного ожидания"
    setTimeout(() => {
      socket.off('userBalance', onBal);
      resolve(null);
    }, 1500);
  });
}, [username, setBalance]);
 



useEffect(() => {
  const start = Date.now();
  const handler = (d) => {
    console.log('[Lobby] first tablesList after', Date.now() - start, 'ms');
    socket.off('tablesList', handler);
  };
  socket.on('tablesList', handler);
  return () => socket.off('tablesList', handler);
}, []);



  // =========================================
  // 7) Наблюдать
  // =========================================
 const watchTable = (tableId) => {
  if (!username) {
    alert("Сначала авторизуйтесь!");
    return;
  }

  const handleLocked = (payload) => {
    longSocket.off('watchLongTable_locked', handleLocked);
    longSocket.off('watchLongTable_allowed', handleAllowed);

    const msg =
      payload?.message ||
      'Сначала выполни квест «Наблюдатель», чтобы смотреть чужие игры.';
    alert(msg);
  };

  const handleAllowed = ({ tableId }) => {
    longSocket.off('watchLongTable_locked', handleLocked);
    longSocket.off('watchLongTable_allowed', handleAllowed);

    try {
      localStorage.removeItem('currentTableId');
      localStorage.removeItem('gameType');
    } catch {}

    // ⚠️ ВАЖНО: после разрешения мы реально заходим как зритель
    longSocket.emit('joinLongTable', {
      longTableId: tableId,
      playerUsername: username,
      isSpectator: true,
    });

    navigate(`/longGame/${tableId}?spectator=1`);
  };

  // 1️⃣ подписываемся
  longSocket.on('watchLongTable_locked', handleLocked);
  longSocket.on('watchLongTable_allowed', handleAllowed);

  // 2️⃣ спрашиваем сервер
  longSocket.emit('watchLongTable', {
  tableId,
  username
});

};


//  const watchTable = (tableId) => {
//   if (!username) {
//     alert("Сначала авторизуйтесь!");
//     return;
//   }

//   try {
//     // просто чистим «игровой» current, ничего лишнего
//     localStorage.removeItem('currentTableId');
//     localStorage.removeItem('gameType');
//     // ❌ БЕЗ sessionRole
//   } catch {}

//   navigate(`/longGame/${tableId}?spectator=1`);
// };


//   const watchTable = (tableId) => {
//   if (!username) {
//     alert("Сначала авторизуйтесь!");
//     return;
//   }

//   navigate(`/longGame/${tableId}?spectator=1`);
// };

// === 7‑а) Наблюдать КОРОТКИЙ стол =========================
// === 7-а) Наблюдать КОРОТКИЙ стол (с проверкой квеста) =========================
// === 7-а) Наблюдать КОРОТКИЙ стол =========================

const watchShortTable = (tableId) => {
  if (!username) {
    alert('Сначала авторизуйтесь!');
    return;
  }

  // Хендлер, если квест НЕ выполнен
  const handleLocked = (payload) => {
    // снимаем подписки, чтобы не было дубликатов
    socket.off('watchTable_locked', handleLocked);
    socket.off('watchTable_allowed', handleAllowed);

    const msg = payload?.message || 'Сначала выполни квест «Наблюдатель», чтобы смотреть чужие игры.';
    alert(msg);
  };

  // Хендлер, если сервер разрешил наблюдать
  const handleAllowed = ({ tableId }) => {
    // снимаем подписки
    socket.off('watchTable_locked', handleLocked);
    socket.off('watchTable_allowed', handleAllowed);

    // Только здесь чистим localStorage и идём на доску
    try {
      localStorage.removeItem('currentTableId');
      localStorage.removeItem('gameType');
    } catch {}

    const table = tables.find(t => t.id === tableId);
    if (table) {
      const base = Number(table.initial_bet) || 1;
      const max  = table.max_bet != null ? Number(table.max_bet) : null;
      localStorage.setItem(
        `stake:short:${tableId}`,
        JSON.stringify({ base, max, updatedAt: Date.now() })
      );
    }

    navigate(`/ShortBackgammonBoard/${tableId}?spectator=1`);
  };

  // ✅ Подписываемся на ответ сервера
  socket.on('watchTable_locked', handleLocked);
  socket.on('watchTable_allowed', handleAllowed);

  // ✅ Просим сервер: "пустишь ли смотреть?"
  socket.emit('watchTable', { tableId });
};







useEffect(() => {
  if (!username) return;

  // 1) сразу
  requestFreshBalance();

  // 2) мягкая повторная через 700мс (часто спасает после выхода со стола)
  const t = setTimeout(() => requestFreshBalance(), 700);

  return () => clearTimeout(t);
}, [username, requestFreshBalance]);

// const watchShortTable = (tableId) => {
//   if (!username) {
//     alert('Сначала авторизуйтесь!');
//     return;
//   }

  
//   // 👇 Зритель: чистим только «игровой» current,
//   // НИКАКИХ ролей больше не трогаем
//   try {
//     localStorage.removeItem('currentTableId');
//     localStorage.removeItem('gameType');
//     // ❌ БОЛЬШЕ НЕ ПИШЕМ sessionRole
//   } catch {}

//   // ставку можно оставить — она не мешает
//   const table = tables.find(t => t.id === tableId);
//   if (table) {
//     const base = Number(table.initial_bet) || 1;
//     const max  = table.max_bet != null ? Number(table.max_bet) : null;
//     localStorage.setItem(
//       `stake:short:${tableId}`,
//       JSON.stringify({ base, max, updatedAt: Date.now() })
//     );
//   }

//   navigate(`/ShortBackgammonBoard/${tableId}?spectator=1`);
// };



// const watchShortTable = (tableId) => {
//   if (!username) {
//     alert('Сначала авторизуйтесь!');
//     return;
//   }
//   navigate(`/ShortBackgammonBoard/${tableId}?spectator=1`);

// const table = tables.find(t => t.id === tableId);
// if (table) {
//   const base = Number(table.initial_bet) || 1;
//   const max  = Number(table.max_bet) || null;
//   localStorage.setItem(
//     `stake:short:${tableId}`,
//     JSON.stringify({ base, max, updatedAt: Date.now() })
//   );
// }
// // navigate(`/ShortBackgammonBoard/${tableId}?spectator=1`);


// };

/* ============================================================
   ПОЛНОЭКРАННЫЙ СПИСОК СТОЛОВ
   ============================================================ */
useEffect(() => {
  if (!tablesExpanded) return undefined;

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      setTablesExpanded(false);
    }
  };

  const lobbyScroller = document.querySelector(
    '.casino-background'
  );

  tablesLobbyScrollRef.current = {
    element: lobbyScroller,
    top: lobbyScroller?.scrollTop || 0,
    left: lobbyScroller?.scrollLeft || 0,
  };

  const calculateFullscreenView = () => {
    const layoutWidth = Number(
      document.documentElement.clientWidth ||
      window.innerWidth ||
      0
    );

    const layoutHeight = Number(
      document.documentElement.clientHeight ||
      window.innerHeight ||
      0
    );

    const screenWidth = Number(
      window.screen?.width || layoutWidth
    );

    const screenHeight = Number(
      window.screen?.height || layoutHeight
    );

    const deviceShortSide = Math.min(
      screenWidth || 9999,
      screenHeight || 9999
    );

    /*
      Без meta viewport телефон обычно получает layout около 980px.
      Слой увеличиваем отдельно, не меняя масштаб самого лобби.
    */
    const compensated =
      deviceShortSide <= 600 &&
      screenWidth > 0 &&
      layoutWidth > screenWidth * 1.15;

    const zoom = compensated
      ? Math.max(
          1,
          Math.min(layoutWidth / screenWidth, 3)
        )
      : 1;

    setTablesFullscreenView({
      compensated,
      zoom,
      width: compensated
        ? `${layoutWidth / zoom}px`
        : '100vw',
      height: compensated
        ? `${layoutHeight / zoom}px`
        : '100dvh',
    });
  };

  calculateFullscreenView();

  window.addEventListener('keydown', onKeyDown);
  window.addEventListener(
    'resize',
    calculateFullscreenView
  );
  window.addEventListener(
    'orientationchange',
    calculateFullscreenView
  );

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      'resize',
      calculateFullscreenView
    );
  }

  document.documentElement.classList.add(
    'cash-tables-open'
  );
  document.body.classList.add('cash-tables-open');

  return () => {
    window.removeEventListener('keydown', onKeyDown);
    window.removeEventListener(
      'resize',
      calculateFullscreenView
    );
    window.removeEventListener(
      'orientationchange',
      calculateFullscreenView
    );

    if (window.visualViewport) {
      window.visualViewport.removeEventListener(
        'resize',
        calculateFullscreenView
      );
    }

    document.documentElement.classList.remove(
      'cash-tables-open'
    );
    document.body.classList.remove(
      'cash-tables-open'
    );

    const saved = tablesLobbyScrollRef.current;

    /*
      Возвращаем игрока ровно в ту точку лобби,
      где он нажал «Развернуть».
    */
    window.requestAnimationFrame(() => {
      if (saved.element) {
        saved.element.scrollTop = saved.top;
        saved.element.scrollLeft = saved.left;
      }

      window.dispatchEvent(new Event('resize'));
    });
  };
}, [tablesExpanded]);


const formatBetInline = (initial, max) => `$${initial}${max ? ` / $${max}` : ''}`;



const renderCashTablesPanel = (expanded = false) => (
  <div
    className={
      'cash-panel' +
      (expanded ? ' cash-panel--expanded' : '') +
      (isOnboardingCashSection
        ? ' onboarding-highlight onboarding-highlight-pulse'
        : '')
    }
  >
    <div className="cash-panel__toolbar">
      {expanded && (
        <div className="cash-panel__title">
          {t('lobby.tables.title')}
        </div>
      )}

      <div className="cash-tabs">
        <button
          type="button"
          className={`cash-tab ${cashTab === 'short' ? 'is-active' : ''}`}
          onClick={goShortTab}
        >
          {t('lobby.tables.short')}
        </button>

        <button
          type="button"
          className={`cash-tab ${cashTab === 'long' ? 'is-active' : ''}`}
          onClick={goLongTab}
        >
          {t('lobby.tables.long')}
        </button>

        <button
          type="button"
          className={`cash-tab ${cashTab === 'khachapuri' ? 'is-active' : ''}`}
          onClick={goKhachapuriTab}
        >
          Хачапури
        </button>
      </div>

      <button
        type="button"
        className={
          expanded
            ? 'cash-expand-btn cash-expand-btn--close'
            : 'cash-expand-btn'
        }
        onClick={() => setTablesExpanded(!expanded)}
        aria-label={
          expanded
            ? t('lobby.tables.collapseAria')
            : t('lobby.tables.expandAria')
        }
        title={
          expanded
            ? t('lobby.tables.collapse')
            : t('lobby.tables.expandFull')
        }
      >
        {expanded ? (
          <>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M7 7l10 10M17 7L7 17" />
            </svg>
            <span>{t('lobby.tables.collapse')}</span>
          </>
        ) : (
          <>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M8 3H3v5M16 3h5v5M21 16v5h-5M3 16v5h5" />
              <path d="M3 8l6-6M21 8l-6-6M21 16l-6 6M3 16l6 6" />
            </svg>
            <span>{t('lobby.tables.expand')}</span>
          </>
        )}
      </button>
    </div>

    <div className="cash-list">
      {(() => {
        const raw =
          cashTab === 'short'
            ? tables
            : cashTab === 'long'
              ? tablesLong
              : tablesKhachapuri;

        const list = raw
          .filter((table) => {
            const status = normStatus(table?.status);
            if (
              cashTab === 'long' &&
              String(table?.name || '').startsWith('BQ-BOT-TEST-')
            ) {
              return false;
            }
            return status !== 'finished' && status !== 'closed';
          })
          .slice()
          .sort((a, b) => {
            const aBet = Number(a.initial_bet) || 0;
            const bBet = Number(b.initial_bet) || 0;
            return aBet - bBet;
          });

        if (list.length === 0) {
          if (cashTab === 'khachapuri') {
            return (
              <div className="cash-empty">
                <div>Столов Хачапури пока нет</div>
                <button
                  className="cash-btn"
                  onClick={refreshKhachapuriTables}
                  disabled={isKhachapuriRefreshing}
                >
                  {isKhachapuriRefreshing
                    ? t('lobby.tables.refreshing')
                    : t('lobby.tables.refresh')}
                </button>
              </div>
            );
          }

          if (cashTab === 'long') {
            return (
              <div className="cash-empty">
                <div>{t('lobby.tables.noneLong')}</div>
                <button
                  className="cash-btn"
                  onClick={refreshLongTables}
                  disabled={isLongRefreshing}
                >
                  {isLongRefreshing
                    ? t('lobby.tables.refreshing')
                    : t('lobby.tables.refresh')}
                </button>
              </div>
            );
          }

          return (
            <div className="cash-empty">
              <div>{t('lobby.tables.noneShort')}</div>
              <button
                className="cash-btn"
                onClick={refreshShortTables}
                disabled={isShortRefreshing}
              >
                {isShortRefreshing
                  ? t('lobby.tables.refreshing')
                  : t('lobby.tables.refresh')}
              </button>
            </div>
          );
        }

        return list.map((table) => {
          const taken = Boolean(
            table.player1_name && table.player2_name
          );

          // Хачапури:
          // max_bet относится только к одиночной партии (Партии 1).
          // В матчах на 3/5/... партий в лобби показываем только initial_bet.
          const isKhachapuriMatch =
            cashTab === 'khachapuri' && Number(table.match_games) > 1;

          const bet = formatBetInline(
            table.initial_bet,
            isKhachapuriMatch ? null : table.max_bet
          );

          const hasPlayers = Boolean(
            table.player1_name || table.player2_name
          );

          return (
            <div
              key={table.id}
              className={
                'cash-row' +
                (hasPlayers ? ' cash-row--busy' : '')
              }
            >
              <div className="cash-cell cash-cell--name">
                {table.player1_name ? (
                  <span className="player-name-with-flag">
                    <CountryFlag
                      countryCode={
                        countryByUsername[table.player1_name]
                      }
                    />
                    <span>{table.player1_name}</span>
                  </span>
                ) : t('lobby.tables.free')}
              </div>

              <div className="cash-cell cash-cell--name">
                {table.player2_name ? (
                  <span className="player-name-with-flag">
                    <CountryFlag
                      countryCode={
                        countryByUsername[table.player2_name]
                      }
                    />
                    <span>{table.player2_name}</span>
                  </span>
                ) : t('lobby.tables.free')}
              </div>

              <div className="cash-cell cash-cell--bet">
                {t('lobby.tables.bet')}&nbsp;{bet}
              </div>

              <div className="cash-cell cash-cell--match">
                {cashTab === 'khachapuri'
                  ? <>Партии&nbsp;{table.match_games}</>
                  : <>{t('lobby.tables.match')}&nbsp;{table.match_points}</>}
              </div>

              {cashTab === 'short'
                ? taken
                  ? (
                    <button className="cash-btn" onClick={() => watchShortTable(table.id)}>
                      {t('lobby.tables.watch')}
                    </button>
                  )
                  : table.status === 'inactive' && (
                    <button className="cash-btn" onClick={() => joinTable(table.id)}>
                      {t('lobby.tables.play')}
                    </button>
                  )
                : cashTab === 'long'
                  ? taken
                    ? (
                      <button className="cash-btn" onClick={() => watchTable(table.id)}>
                        {t('lobby.tables.watch')}
                      </button>
                    )
                    : table.status === 'inactive' && (
                      <button className="cash-btn" onClick={() => joinLongTable(table.id)}>
                        {t('lobby.tables.play')}
                      </button>
                    )
                  : taken
                    ? (
                      <button className="cash-btn" onClick={() => watchKhachapuriTable(table.id)}>
                        {t('lobby.tables.watch')}
                      </button>
                    )
                    : table.status === 'inactive' && (
                      <button className="cash-btn" onClick={() => joinKhachapuriTable(table.id)}>
                        {t('lobby.tables.play')}
                      </button>
                    )}
            </div>
          );
        });
      })()}
    </div>
  </div>
);

const rightSlot = renderCashTablesPanel(false);

// =========================================
// РЕЙТИНГ: живой «Зал славы» с пьедесталом ТОП-3
// =========================================
const getRatingValue = (user) => {
  const value = ratingTab === 'short' ? user?.short_rating : user?.long_rating;
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const getRatingAvatar = (user) => {
  const candidates = [
    user?.avatar_url,
    user?.avatarUrl,
    user?.avatar,
    user?.photo_url,
    user?.photoUrl,
    user?.photo,
    user?.image_url,
    user?.imageUrl,
    user?.image,
  ];

  return candidates.find(
    (value) => typeof value === 'string' && value.trim().length > 0
  ) || null;
};

const getRatingInitials = (name) => {
  const clean = String(name || '?').trim();
  if (!clean) return '?';

  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
  }

  return clean.slice(0, 2).toUpperCase();
};

const ratingUsers = allUsers
  .slice()
  .sort((a, b) => getRatingValue(b) - getRatingValue(a));

const ratingTopTen = ratingUsers.slice(0, 10);
const ratingTopThree = ratingTopTen.slice(0, 3);
const ratingPlacesFourToTen = ratingTopTen.slice(3, 10);
const ratingOthers = ratingUsers.slice(10);

const normalizedCurrentUsername = String(username || '').trim().toLowerCase();
const myRatingIndex = normalizedCurrentUsername
  ? ratingUsers.findIndex(
      (user) => String(user?.username || '').trim().toLowerCase() === normalizedCurrentUsername
    )
  : -1;

const myRatingPlace = myRatingIndex >= 0 ? myRatingIndex + 1 : null;
const myRatingUser = myRatingIndex >= 0 ? ratingUsers[myRatingIndex] : null;
const myRatingValue = myRatingUser ? getRatingValue(myRatingUser) : null;
const tenthRatingValue = ratingUsers.length >= 10 ? getRatingValue(ratingUsers[9]) : null;
const pointsToTopTen =
  myRatingPlace && myRatingPlace > 10 && tenthRatingValue !== null
    ? Math.max(1, tenthRatingValue - myRatingValue + 1)
    : 0;

const podiumRenderOrder = [
  { user: ratingTopThree[1], place: 2 },
  { user: ratingTopThree[0], place: 1 },
  { user: ratingTopThree[2], place: 3 },
].filter((item) => item.user);

const renderRatingAvatar = (user, place, sizeClass = '') => {
  const avatar = getRatingAvatar(user);
  const name = user?.username || t('lobby.rating.playerFallback');

  return (
    <div className={`rating-avatar rating-avatar--${place} ${sizeClass}`.trim()}>
      <span className="rating-avatar__fallback" aria-hidden="true">
        {getRatingInitials(name)}
      </span>
      {avatar && (
        <img
          className="rating-avatar__image"
          src={avatar}
          alt={t('lobby.rating.avatarAlt', { name })}
          loading="lazy"
          onError={(event) => {
            event.currentTarget.remove();
          }}
        />
      )}
    </div>
  );
};

const ratingSlot = (
  <div
    className={
      'cash-panel rating-hall' +
      (isOnboardingRatingSection ? ' onboarding-highlight onboarding-highlight-pulse' : '')
    }
  >
    <div className="rating-hall__ambient" aria-hidden="true">
      <span className="rating-spark rating-spark--1" />
      <span className="rating-spark rating-spark--2" />
      <span className="rating-spark rating-spark--3" />
      <span className="rating-spark rating-spark--4" />
      <span className="rating-spark rating-spark--5" />
      <span className="rating-spark rating-spark--6" />
    </div>

    <div className="rating-hall__shine" aria-hidden="true" />

    <div className="rating-hall__header">
      <div className="rating-hall__title-wrap">
        <div className="rating-hall__trophy" aria-hidden="true">
          <svg viewBox="0 0 64 64" focusable="false">
            <path d="M21 8h22v9c0 10-5 18-11 18s-11-8-11-18V8Z" />
            <path d="M21 13H10v5c0 9 6 15 15 16M43 13h11v5c0 9-6 15-15 16" />
            <path d="M28 35h8v10h9v7H19v-7h9V35Z" />
          </svg>
        </div>

        <div>
          <div className="rating-hall__eyebrow">{t('lobby.rating.hallOfFame')}</div>
          <h2 className="rating-hall__title">{t('lobby.rating.topPartnersSeason')}</h2>
          <p className="rating-hall__subtitle">
            {t('lobby.rating.subtitle')}
          </p>
        </div>
      </div>

      <div className="rating-hall__tabs cash-tabs" role="tablist" aria-label={t('lobby.rating.tabsAria')}>
        <button
          type="button"
          className={`cash-tab ${ratingTab === 'short' ? 'is-active' : ''}`}
          onClick={() => setRatingTab('short')}
          role="tab"
          aria-selected={ratingTab === 'short'}
        >
          {t('lobby.rating.short')}
        </button>
        <button
          type="button"
          className={`cash-tab ${ratingTab === 'long' ? 'is-active' : ''}`}
          onClick={() => setRatingTab('long')}
          role="tab"
          aria-selected={ratingTab === 'long'}
        >
          {t('lobby.rating.long')}
        </button>
      </div>
    </div>

    {ratingUsers.length === 0 ? (
      <div className="rating-hall__empty">
        {t('lobby.rating.empty')}
      </div>
    ) : (
      <>
        <div className="rating-hall__main">
          <div className="rating-podium-zone">
            <div className="rating-podium-stage">
              {podiumRenderOrder.map(({ user, place }) => {
                const ratingValue = getRatingValue(user);
                const isChampion = place === 1;

                return (
                  <div
                    key={`${user.id ?? user.username}-${place}`}
                    className={`rating-podium rating-podium--${place}`}
                  >
                    {isChampion && (
                      <div className="rating-podium__crown" aria-hidden="true">
                        <svg viewBox="0 0 72 52" focusable="false">
                          <path d="M7 39 4 12l18 13L36 4l14 21 18-13-3 27H7Z" />
                          <path d="M10 43h52v6H10z" />
                        </svg>
                      </div>
                    )}

                    <div className="rating-podium__medal" aria-label={t('lobby.rating.placeAria', { place })}>
                      {place}
                    </div>

                    <div className="rating-podium__halo" aria-hidden="true" />
                    {renderRatingAvatar(user, place)}

                    <div className="rating-podium__identity">
                      <div className="rating-podium__name-row">
                        <CountryFlag countryCode={countryByUsername[user.username]} />
                        <span className="rating-podium__name" title={user.username}>
                          {user.username}
                        </span>
                      </div>
                      <div className="rating-podium__score">
                        <span>{ratingValue}</span>
                        <small>{t('lobby.rating.ratingLabel')}</small>
                      </div>
                    </div>

                    <div className="rating-podium__base">
                      <span className="rating-podium__base-number">{place}</span>
                      <span className="rating-podium__base-label">{t('lobby.rating.placeLabel')}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <aside className="rating-partner-card">
            <div className="rating-partner-card__icon" aria-hidden="true">
              <svg viewBox="0 0 64 64" focusable="false">
                <path d="M8 26 20 14l9 7-8 9 8 8 7-7 7 7 8-8-8-9 9-7 12 12-9 9 4 4-7 7-4-4-6 6-5-5-5 5-6-6-4 4-7-7 4-4-9-9Z" />
              </svg>
            </div>
            <div className="rating-partner-card__kicker">{t('lobby.rating.partnerPrize')}</div>
            <div className="rating-partner-card__title">{t('lobby.rating.partnership')}</div>
            <ul className="rating-partner-card__list">
              <li><span>◆</span> {t('lobby.rating.createTournaments')}</li>
              <li><span>◆</span> {t('lobby.rating.invitePlayers')}</li>
              <li><span>◆</span> {t('lobby.rating.earnFromActivity')}</li>
            </ul>
            <div className="rating-partner-card__note">
              {t('lobby.rating.partnerNote')}
            </div>
          </aside>
        </div>

        <div className="rating-top-list" aria-label={t('lobby.rating.placesFourToTenAria')}>
          <div className="rating-top-list__head">
            <span>#</span>
            <span>{t('lobby.rating.playerColumn')}</span>
            <span>{t('lobby.rating.ratingColumn')}</span>
            <span>{t('lobby.rating.statusColumn')}</span>
          </div>

          {ratingPlacesFourToTen.map((user, index) => {
            const place = index + 4;
            const isMe =
              normalizedCurrentUsername &&
              String(user?.username || '').trim().toLowerCase() === normalizedCurrentUsername;

            return (
              <div
                key={user.id ?? `${user.username}-${place}`}
                className={`rating-top-list__row ${isMe ? 'is-me' : ''}`}
              >
                <div className="rating-top-list__place">#{place}</div>
                <div className="rating-top-list__player">
                  {renderRatingAvatar(user, place, 'rating-avatar--small')}
                  <div className="rating-top-list__player-text">
                    <div className="rating-top-list__name-row">
                      <CountryFlag countryCode={countryByUsername[user.username]} />
                      <span title={user.username}>{user.username}</span>
                    </div>
                    {isMe && <small>{t('lobby.rating.you')}</small>}
                  </div>
                </div>
                <div className="rating-top-list__score">{getRatingValue(user)}</div>
                <div className="rating-top-list__status">{t('lobby.rating.topTenZone')}</div>
              </div>
            );
          })}

          <div
            className={`rating-my-place rating-my-place--grid ${
              myRatingPlace && myRatingPlace <= 10 ? 'is-top-ten' : ''
            }`}
          >
            <div className="rating-my-place__label">{t('lobby.rating.yourPosition')}</div>
            {myRatingPlace ? (
              <>
                <div className="rating-my-place__place">#{myRatingPlace}</div>
                <div className="rating-my-place__score">{t('lobby.rating.scoreValue', { count: myRatingValue })}</div>
                <div className="rating-my-place__message">
                  {myRatingPlace <= 10
                    ? t('lobby.rating.youAreTopTen')
                    : t('lobby.rating.pointsToTopTen', { count: pointsToTopTen })}
                </div>
              </>
            ) : (
              <div className="rating-my-place__message">
                {username ? t('lobby.rating.playRatedMatch') : t('lobby.rating.signIn')}
              </div>
            )}
          </div>
        </div>

        {ratingOthers.length > 0 && (
          <details className="rating-full-list">
            <summary>
              <span>{t('lobby.rating.showPlaces11Plus')}</span>
              <span className="rating-full-list__arrow" aria-hidden="true">⌄</span>
            </summary>
            <div className="rating-full-list__body">
              {ratingOthers.map((user, index) => {
                const place = index + 11;
                const isMe =
                  normalizedCurrentUsername &&
                  String(user?.username || '').trim().toLowerCase() === normalizedCurrentUsername;

                return (
                  <div
                    key={user.id ?? `${user.username}-${place}`}
                    className={`rating-full-list__row ${isMe ? 'is-me' : ''}`}
                  >
                    <span className="rating-full-list__place">#{place}</span>
                    <span className="rating-full-list__player">
                      <CountryFlag countryCode={countryByUsername[user.username]} />
                      <span title={user.username}>{user.username}</span>
                    </span>
                    <span className="rating-full-list__score">{getRatingValue(user)}</span>
                  </div>
                );
              })}
            </div>
          </details>
        )}
      </>
    )}
  </div>
);

// Слоты правой колонки.
// Для обычного лобби рейтинг теперь передаём TournamentLobby отдельно,
// чтобы он стоял во втором ряду ровно напротив маленьких jackpot-карточек.
const wheelSlot = (
  <div
    className={
      "wheel-fixed-layer" +
      (isOnboardingWheelSection ? " onboarding-highlight onboarding-highlight-pulse" : "")
    }
  >
    <LobbyFortune
      username={username}
      level={userLevel}
      vipTier={userVip}
    />
  </div>
);

// Столы + колесо: это правый блок первого ряда.
const rightSlotWithWheel = (
  <div className="right-panel-stack">
    {rightSlot}
    {wheelSlot}
  </div>
);

// Для гостевого/standalone режима оставляем старую последовательность:
// столы -> колесо -> рейтинг.
const rightSlotWithRating = (
  <div className="right-panel-stack">
    {rightSlot}
    {wheelSlot}
    <div className="rating-under-tables">
      {ratingSlot}
    </div>
  </div>
);

// Для TournamentLobby рейтинг идёт отдельным слотом во втором ряду.
const tournamentRatingSlot = (
  <div className="rating-under-tables">
    {ratingSlot}
  </div>
);


// const rightSlotWithRating = (
//   <div className="right-panel-stack">

//     {/* 1. Таблицы */}
//     {rightSlot}

//     {/* 2. Колесо (должно стоять здесь!) */}
//     <div className="wheel-fixed-layer">
//     <LobbyFortune 
//       username={username} 
//       level={userLevel} 
//       vipTier={userVip} 
//     />
//     </div>
//     {/* 3. Рейтинг */}
//     <div className="rating-under-tables">
//       {ratingSlot}
//     </div>

//   </div>
// );

  // =========================================
  // Меню и прочее
  // =========================================
  const minimizedTables = Object.keys(tableStates || {}).filter(
    (id) => tableStates[id]?.isMinimized && !tableStates[id]?.isClosed
  );

  const formatBet = (initialBet, maxBet) => {
    return `$${initialBet}${maxBet ? ` / $${maxBet}` : ''}`;
  };
 

  if (isGuest) {
  return (
    <div className="guest-hero">
      <div className="guest-hero__bg" />
      <div className="guest-hero__card">
        <div className="guest-hero__brand">BACKGAMMON QUEST</div>

        <h1 className="guest-hero__title">
          JACKPOT<br/>TOURNAMENT
        </h1>

        <div className="guest-hero__prize">
          PRIZE <span>$5000</span>
        </div>

        <div className="guest-hero__actions">
          <button className="btn-gold" onClick={() => navigate('/register')}>
            {t('lobby.guest.register')}
          </button>
          <button className="btn-dark" onClick={() => navigate('/login')}>
            {t('lobby.guest.login')}
          </button>
        </div>

        <p className="guest-hero__hint">
          {t('lobby.guest.hint')}
        </p>
      </div>
    </div>
  );
}


   return (
  <div className={`casino-background ${isMobile ? 'mobile-fullscreen' : ''}`}>

    {tablesExpanded &&
      createPortal(
        <div
          className={
            'cash-tables-fullscreen cash-tables-fullscreen--portal' +
            (tablesFullscreenView.compensated
              ? ' cash-tables-fullscreen--compensated'
              : '')
          }
          style={{
            width: tablesFullscreenView.width,
            height: tablesFullscreenView.height,
            zoom: tablesFullscreenView.zoom,
          }}
          role="dialog"
          aria-modal="true"
          aria-label={t('lobby.tables.allTables')}
        >
          <div className="cash-tables-fullscreen__surface">
            {renderCashTablesPanel(true)}
          </div>
        </div>,
        document.body
      )}


 {/* 👇 Модальное обучение поверх лобби */}
     {!isMobile && showOnboarding && (
  <div
     className={(() => {
      let cls = 'onboarding-backdrop';

      if (onboardingStep === 1) {
        cls += ' onboarding-backdrop--right';
      } else if (onboardingStep === 2) {
        cls += ' onboarding-backdrop--left';
      }

      // шаги 5–7: убираем затемнение, оставляем только подсветку + модалку
      if (onboardingStep >= 5 && onboardingStep <= 7) {
        cls += ' onboarding-backdrop--nodim';
      }

      return cls;
    })()}
  >
    <div className="onboarding-modal">
            {onboardingStep === 0 ? (
              <>
                <h2 className="onboarding-title">
                  {t('lobby.onboarding.welcomeTitle')}
                </h2>
                <p className="onboarding-text">
                  {t('lobby.onboarding.welcomeText')}
                </p>
                <div className="onboarding-buttons">
                  <button
                    type="button"
                    className="onboarding-btn primary"
                    onClick={handleOnboardingStart}
                  >
                    {t('lobby.onboarding.start')}
                  </button>
                  <button
                    type="button"
                    className="onboarding-btn secondary"
                    onClick={handleOnboardingSkip}
                  >
                    {t('lobby.onboarding.later')}
                  </button>
                </div>
              </>
            ) : (
              <>
                <h2 className="onboarding-title">
                  {onboardingSlides[onboardingStep]?.title}
                </h2>
                <p className="onboarding-text">
                  {onboardingSlides[onboardingStep]?.text}
                </p>

                <div className="onboarding-buttons">
                  <button
                    type="button"
                    className="onboarding-btn secondary"
                    onClick={handleOnboardingSkip}
                  >
                    {t('lobby.onboarding.skip')}
                  </button>

                  {onboardingStep > 1 && (
                    <button
                      type="button"
                      className="onboarding-btn secondary"
                      onClick={handleOnboardingPrev}
                    >
                      {t('lobby.onboarding.back')}
                    </button>
                  )}

                  <button
                    type="button"
                    className="onboarding-btn primary"
                    onClick={handleOnboardingNext}
                  >
                    {onboardingStep >= onboardingSlides.length - 1
                      ? t('lobby.onboarding.finish')
                      : t('lobby.onboarding.next')}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}



  {!isGuest && (
      <SupportChatWidget username={username} token={token} />
    )}

     {/* 👇 Кнопка, чтобы игрок сам мог вернуть обучение в лобби */}
{!isMobile && !isGuest && (
  <button
    type="button"
    className="onboarding-reopen-btn"
    onClick={() => {
      setOnboardingStep(1);     // или 0, если хочешь с приветствия
      setShowOnboarding(true);
    }}
    aria-label={t('lobby.onboarding.openAria')}
  >
    ?
  </button>
)}


  
{!username ? (
  <div className="right-panel-standalone">
    {rightSlotWithRating}
  </div>
) : (
  <>
    {/* Основные jackpot-карточки short/long */}
    <TournamentLobby
      username={username}
      tournaments={shortTournaments}
      typeGame={typeGame}
      rightSlot={rightSlotWithWheel}
      ratingSlot={tournamentRatingSlot}
      refreshTick={tournamentRefreshTick}
      refreshShortTables={refreshShortTables}
      refreshLongTables={refreshLongTables}
      highlight={isOnboardingTournamentCards}
    />

    {/* Возвращаем старую long-tournament связку.
        Компонент нужен для long namespace / приглашений / обновлений турниров. */}
    <LongTournamentLobby
      tournaments={longTournaments}
      username={username}
      typeGame={typeGame}
    />
  </>
)}



<CashFortuneBarOverlay
  show={cashWheel.show}
  segments={cashWheel.segments}
  selectedId={cashWheel.selectedId}
  title={cashWheel.title}
  onCollect={handleCollectPrize}
  onHide={() => setCashWheel(s => ({ ...s, show: false }))}

  /* окно видимости: теперь 5 карт */
  visibleCount={5}
  startIndex={0}           // сервер будет сдвигать окно по ленте
  edgesHalfVisible={true}  // 1-я и 5-я торчат на полкарты
  useAutoRotation={true}   // ПОВОРОТ вдоль дуги автоматически

  /* общие параметры ряда/дуги (можно не трогать) */
  // gap={10}
  // aspect={0.24}
  // size={0.80}
  // sagittaPct={0.80}
  // topOffset={-220}
gap={12}          // расстояние между картами
aspect={0.58}     // высота умеренная (≈1.7x меньше, чем у тебя сейчас)
size={0.95}       // чуть меньше, чем 1: карты не слишком крупные
sagittaPct={0.52} // дуга плавная
topOffset={-240}  // выравниваем центр по высоте
viewportHeight={320}


  /* слева→направо: 5 штук, ступенчато по высоте */
layoutLtr={[
  // #1 крайняя левая
  { dx: 50, dy: 680, rot: 30 },

  { dx: -50,   dy: 110,  rot: -2 },      
  { dx: -10,   dy: -70, upright: true },
  { dx: 30,   dy: 80,  rot: 4 },       
  { dx: -50, dy: 630, rot: 330 },     // #5 крайняя правая
]}

/>

 <SpinWheelOverlay /> 


  

      <div className="overlay"></div>
      <div className="tablo-container">
        <nav className="menu" id="menu">
          <a
            className={`menu-item ${typeGame === 0 ? 'active' : ''}`}
            href="#menu"
            onClick={() => setTypeGame(0)}
          >
            {/* <span className="text">BACKGAMMON</span> */}
          </a>
          <a
            className={`menu-item ${typeGame === 1 ? 'active' : ''}`}
            href="#menu"
            onClick={() => setTypeGame(1)}
          >
         
          </a>
        
        </nav>

     
    






        {typeGame === 2 && <h1>Game Type 2</h1>}
      </div>
    </div>
  );
};

export default Lobby;

